import { createTheme as Sn, css as d, keyframes as wn, useTheme as ho, useMediaQuery as De, styled as $, TextField as mo, InputAdornment as Qe, checkboxClasses as sr, boxClasses as qe, fabClasses as It, Box as re, Checkbox as xo, Radio as $o, IconButton as vo, Button as So, CircularProgress as dr, Rating as wo, ratingClasses as ko, Slider as To, inputClasses as Ae, inputAdornmentClasses as ot, Input as Eo, Typography as Ee, Select as _o, selectClasses as Co, MenuItem as yt, menuItemClasses as Er, ListSubheader as Oo, Stack as ge, circularProgressClasses as kn, Skeleton as Po, tableCellClasses as Mo, TableCell as Ao, TableRow as Ro, TableBody as Tn, Table as Io, tooltipClasses as Me, Tooltip as zo, LinearProgress as Fo, Dialog as En, DialogTitle as _n, modalClasses as Do, dialogClasses as zt, Divider as jo, Link as No, Paper as Lo, Popper as Bo, Fade as Wo, ClickAwayListener as qo, MenuList as Vo, MobileStepper as Uo, Tab as Ho, Tabs as Yo, tabsClasses as Ko, paginationClasses as Go, paginationItemClasses as Sr, Pagination as Xo, PaginationItem as Jo, Snackbar as Zo } from "@mui/material";
import { useMemo as Qo, useState as ht, forwardRef as ye, Children as ei, isValidElement as ri, cloneElement as Cn, useCallback as ti, Fragment as ni, useRef as oi, useEffect as On } from "react";
import { jsx as u, jsxs as Y, Fragment as ii } from "react/jsx-runtime";
import { Done as ai, InfoOutlined as si } from "@mui/icons-material";
import { CheckIcon as ci, MinusIcon as li, StarIcon as Ft, CheckMarkIcon as Pn, AlertCircleIcon as ui, ChevronDownIcon as di, BackIcon as pi, CloseIcon as mt, ChevronLeftIcon as Mn, ChevronRightIcon as An, AlertTriangleIcon as fi } from "@braskai/icons";
import gi from "@emotion/styled";
import { CacheProvider as bi, Global as yi, ThemeContext as hi, css as Rn, keyframes as mi } from "@emotion/react";
const xi = {
  values: {
    mobile: 0,
    mobileMedium: 375,
    mobileLarge: 480,
    tablet: 768,
    laptop: 1024,
    desktop: 1280
  }
}, $i = {
  xs: "0px 1px 2px rgba(16, 24, 40, 0.05)",
  sm: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
  md: "0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
  lg: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
  xl: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  "2xl": "0px 24px 48px -12px rgba(16, 24, 40, 0.18)",
  "3xl": "0px 32px 64px -12px rgba(16, 24, 40, 0.14)"
}, zr = {
  common: {
    white: "#FFFFFF",
    black: "#000000"
  },
  grey: {
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F2F4F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    800: "#1D2939",
    900: "#101828"
  },
  primary: {
    25: "#FAFAFF",
    50: "#F5F5FF",
    100: "#E7E7FC",
    150: "#D1D1FA",
    200: "#B4B4F7",
    300: "#8F8FF3",
    400: "#5C5CED",
    500: "#3D3DE9",
    600: "#0B0BCF",
    700: "#0909A2",
    800: "#07077D",
    900: "#050560"
  },
  error: {
    25: "#FFFBFA",
    50: "#FEF3F2",
    100: "#FEE4E2",
    200: "#FECDCA",
    300: "#FDA29B",
    400: "#F97066",
    500: "#F04438",
    600: "#D92D20",
    700: "#B42318",
    800: "#912018",
    900: "#7A271A"
  },
  warning: {
    25: "#FFFCF5",
    50: "#FFFAEB",
    100: "#FEF0C7",
    200: "#FEDF89",
    300: "#FEC84B",
    400: "#FDB022",
    500: "#F79009",
    600: "#DC6803",
    700: "#B54708",
    800: "#93370D",
    900: "#7A2E0E"
  },
  success: {
    25: "#F6FEF9",
    50: "#ECFDF3",
    100: "#D1FADF",
    200: "#A6F4C5",
    300: "#6CE9A6",
    400: "#32D583",
    500: "#12B76A",
    600: "#039855",
    700: "#027A48",
    800: "#05603A",
    900: "#054F31"
  }
}, xt = "Inter Tight", vi = {
  "title-1-md": {
    fontFamily: "Inter Tight",
    fontWeight: 500,
    fontSize: 36,
    lineHeight: "44px"
  },
  "title-2-md": {
    fontFamily: "Inter Tight",
    fontWeight: 500,
    fontSize: 30,
    lineHeight: "36px"
  },
  "title-3-md": {
    fontFamily: "Inter Tight",
    fontWeight: 500,
    fontSize: 24,
    lineHeight: "30px"
  },
  "title-4-md": {
    fontFamily: "Inter Tight",
    fontWeight: 500,
    fontSize: 18,
    lineHeight: "22px"
  },
  "body-1-md": {
    fontFamily: "Inter Tight",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "22px"
  },
  "body-2-md": {
    fontFamily: "Inter Tight",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "20px"
  },
  "caption-1-md": {
    fontFamily: "Inter Tight",
    fontWeight: 500,
    fontSize: 12,
    lineHeight: "16px"
  },
  "caption-2-md": {
    fontFamily: "Inter Tight",
    fontWeight: 500,
    fontSize: 10,
    lineHeight: "12px"
  },
  "title-1-sb": {
    fontFamily: "Inter Tight",
    fontWeight: 600,
    fontSize: 36,
    lineHeight: "44px"
  },
  "title-2-sb": {
    fontFamily: "Inter Tight",
    fontWeight: 600,
    fontSize: 30,
    lineHeight: "36px"
  },
  "title-3-sb": {
    fontFamily: "Inter Tight",
    fontWeight: 600,
    fontSize: 24,
    lineHeight: "30px"
  },
  "title-4-sb": {
    fontFamily: "Inter Tight",
    fontWeight: 600,
    fontSize: 18,
    lineHeight: "22px"
  },
  "body-1": {
    fontFamily: "Inter Tight",
    fontWeight: 400,
    fontSize: 16,
    lineHeight: "22px"
  },
  "body-2": {
    fontFamily: "Inter Tight",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "20px"
  },
  "caption-1": {
    fontFamily: "Inter Tight",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "16px"
  },
  "caption-2": {
    fontFamily: "Inter Tight",
    fontWeight: 400,
    fontSize: 10,
    lineHeight: "12px"
  }
}, Si = {
  h1: void 0,
  h2: void 0,
  subtitle1: void 0,
  subtitle2: void 0,
  h3: void 0,
  h4: void 0,
  h5: void 0,
  h6: void 0,
  overline: void 0,
  body1: void 0,
  body2: void 0,
  caption: void 0,
  button: void 0
}, wi = {
  negative: -1,
  zero: 0,
  basic: 1,
  sidebar: 2,
  popover: 3,
  popup: 4,
  loader: 5,
  dialog: 6
}, ki = {
  palette: zr,
  typography: {
    fontFamily: xt,
    ...Si,
    ...vi
  },
  customShadows: $i,
  breakpoints: xi,
  zIndex: wi
}, ce = Sn(ki, {}), ae = Sn(ce, {
  spacing: (e) => `${e}px`,
  shape: {
    borderRadius: 1
  },
  palette: {
    secondary: {
      main: ce.palette.grey[500]
    }
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
      }
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          textMdRegular: "span"
        }
      },
      styleOverrides: {
        root: {
          fontFamily: xt,
          color: ce.palette.grey[900]
        }
      },
      variants: [
        {
          props: {
            color: "success"
          },
          style: {
            color: ce.palette.success[700]
          }
        }
      ]
    },
    MuiCssBaseline: {
      styleOverrides: {
        [ce.breakpoints.up("tablet")]: {
          body: {
            scrollbarColor: `${ce.palette.grey[400]} ${ce.palette.grey[50]}`
          },
          "::-webkit-scrollbar": {
            width: 8
          },
          "::-webkit-scrollbar-track": {
            background: ce.palette.grey[50]
          },
          "::-webkit-scrollbar-thumb": {
            background: ce.palette.grey[400],
            borderRadius: 100
          },
          "::-webkit-scrollbar-thumb:hover": {
            background: ce.palette.grey[500]
          }
        }
      }
    },
    MuiSvgIcon: {
      defaultProps: {
        color: "secondary"
      },
      variants: [
        {
          props: {
            color: "secondary"
          },
          style: {
            color: ce.palette.grey[500]
          }
        },
        {
          props: {
            color: "white"
          },
          style: {
            color: ce.palette.common.white
          }
        },
        {
          props: {
            color: "primary"
          },
          style: {
            color: ce.palette.primary[600]
          }
        },
        {
          props: {
            color: "error"
          },
          style: {
            color: ce.palette.error[500]
          }
        },
        {
          props: {
            fontSize: "small"
          },
          style: {
            fontSize: 16
          }
        },
        {
          props: {
            fontSize: "medium"
          },
          style: {
            fontSize: 20
          }
        },
        {
          props: {
            fontSize: "large"
          },
          style: {
            fontSize: 24
          }
        },
        {
          props: {
            fontSize: "extraLarge"
          },
          style: {
            fontSize: 60
          }
        }
      ]
    }
  }
}), be = (e) => d`
  min-width: ${e}px;
  max-width: ${e}px;
  min-height: ${e}px;
  max-height: ${e}px;
`, Re = (e) => {
  const r = ae.typography[e];
  return `
    font-weight: ${r.fontWeight};
    font-size: ${r.fontSize}px;
    line-height: ${r.lineHeight};
    letter-spacing: ${r.letterSpacing ? r.letterSpacing : "normal"};
  `;
}, In = d`
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
`, zn = (e) => d`
  overflow: hidden;
  word-break: break-word;
  display: -webkit-box;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${e};
`, ve = {
  shouldForwardProp: (e) => !e.startsWith("$")
}, Ti = {
  ocean: {
    50: "rgba(241, 248, 254, 1)",
    100: "rgba(229, 241, 254, 1)",
    200: "rgba(216, 235, 254, 1)",
    300: "rgba(127, 191, 254, 1)",
    500: "rgba(122, 176, 229, 1)",
    600: "rgba(41, 122, 204, 1)"
  },
  midnight: {
    50: "rgba(241, 243, 254, 1)",
    100: "rgba(229, 233, 254, 1)",
    200: "rgba(216, 222, 254, 1)",
    300: "rgba(127, 148, 254, 1)",
    500: "rgba(122, 140, 229, 1)",
    600: "rgba(41, 68, 204, 1)"
  },
  amethyst: {
    50: "rgba(248, 241, 254, 1)",
    100: "rgba(241, 229, 254, 1)",
    200: "rgba(235, 216, 254, 1)",
    300: "rgba(191, 127, 254, 1)",
    500: "rgba(176, 122, 229, 1)",
    600: "rgba(122, 41, 204, 1)"
  },
  orchid: {
    50: "rgba(254, 241, 250, 1)",
    100: "rgba(254, 229, 246, 1)",
    200: "rgba(254, 216, 241, 1)",
    300: "rgba(254, 127, 213, 1)",
    500: "rgba(229, 122, 193, 1)",
    600: "rgba(204, 41, 150, 1)"
  },
  crimson: {
    50: "rgba(254, 241, 241, 1)",
    100: "rgba(254, 229, 229, 1)",
    200: "rgba(254, 216, 216, 1)",
    300: "rgba(254, 127, 127, 1)",
    500: "rgba(229, 122, 122, 1)",
    600: "rgba(204, 41, 41, 1)"
  },
  tiger: {
    50: "rgba(254, 248, 241, 1)",
    100: "rgba(254, 241, 229, 1)",
    200: "rgba(254, 235, 216, 1)",
    300: "rgba(254, 188, 127, 1)",
    500: "rgba(229, 176, 122, 1)",
    600: "rgba(166, 99, 33, 1)"
  },
  bronze: {
    50: "rgba(255, 253, 242, 1)",
    100: "rgba(247, 243, 223, 1)",
    200: "rgba(242, 236, 206, 1)",
    300: "rgba(240, 220, 120, 1)",
    500: "rgba(197, 183, 113, 1)",
    600: "rgba(128, 111, 26, 1)"
  },
  olive: {
    50: "rgba(253, 255, 242, 1)",
    100: "rgba(243, 247, 223, 1)",
    200: "rgba(236, 242, 206, 1)",
    300: "rgba(215, 235, 117, 1)",
    500: "rgba(118, 128, 73, 1)",
    600: "rgba(111, 128, 26, 1)"
  },
  forest: {
    50: "rgba(247, 255, 242, 1)",
    100: "rgba(231, 247, 223, 1)",
    200: "rgba(218, 242, 206, 1)",
    300: "rgba(153, 229, 115, 1)",
    500: "rgba(140, 197, 113, 1)",
    600: "rgba(59, 128, 26, 1)"
  },
  teal: {
    50: "rgba(218, 242, 206, 1)",
    100: "rgba(223, 247, 231, 1)",
    200: "rgba(206, 242, 218, 1)",
    300: "rgba(115, 229, 153, 1)",
    500: "rgba(115, 210, 146, 1)",
    600: "rgba(26, 128, 59, 1)"
  },
  sapphire: {
    50: "rgba(242, 255, 253, 1)",
    100: "rgba(223, 247, 243, 1)",
    200: "rgba(206, 242, 236, 1)",
    300: "rgba(115, 229, 210, 1)",
    500: "rgba(115, 210, 195, 1)",
    600: "rgba(26, 128, 111, 1)"
  },
  cerulean: {
    50: "rgba(242, 253, 255, 1)",
    100: "rgba(223, 243, 247, 1)",
    200: "rgba(206, 236, 242, 1)",
    300: "rgba(115, 210, 229, 1)",
    500: "rgba(115, 195, 210, 1)",
    600: "rgba(26, 111, 128, 1)"
  }
}, gd = Object.keys(Ti), bd = (e) => e && Number(e) ? `${e}px` : "", yd = wn`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, Ei = Object.keys(zr), hd = () => Ei.reduce((e, r) => {
  const n = Object.keys(zr[r]).map((o) => `${r}.${o}`);
  return [
    ...e,
    ...n
  ];
}, []), Dt = (e) => {
  const [r, t] = e.split(".");
  return zr[r][t];
}, Fn = ({ between: e = [
  0,
  0
] } = {}) => {
  const r = ho(), t = De(r.breakpoints.between(0, "tablet")), n = De(r.breakpoints.between(0, "mobileMedium")), o = De(r.breakpoints.between("mobileMedium", "mobileLarge")), i = De(r.breakpoints.between("mobileLarge", "tablet")), a = De(r.breakpoints.between("tablet", "laptop")), s = De(r.breakpoints.between("laptop", "desktop")), c = De(r.breakpoints.up("desktop")), l = De(r.breakpoints.between(e[0], e[1]));
  return Qo(() => ({
    isMobile: t,
    isMobileSmall: n,
    isMobileMedium: o,
    isMobileLarge: i,
    isLaptop: s,
    isDesktop: c,
    isTablet: a,
    isScreenWidthBetween: l
  }), [
    c,
    s,
    t,
    i,
    o,
    n,
    l,
    a
  ]);
}, _i = async (e = 1e3) => new Promise((r) => {
  setTimeout(r, e);
}), md = () => {
}, xd = (e, r = 0) => {
  const [t, n] = ht(!1);
  return {
    copy: async () => {
      !navigator.clipboard || t || (n(!0), await navigator.clipboard.writeText(e), await _i(r), n(!1));
    },
    isCopied: t
  };
}, Ci = /* @__PURE__ */ $(mo, {
  shouldForwardProp: (e) => ![
    "extraHeight",
    "success",
    "borderless"
  ].includes(e),
  target: "e1xg0icd0"
})(({ borderless: e, theme: r, extraHeight: t, success: n }) => d`
    min-height: ${t ? "71px" : "auto"};

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 40rem ${r.palette.common.white} inset;

      &:hover,
      &:focus {
        -webkit-box-shadow: 0 0 0 40rem ${r.palette.common.white} inset;
      }
    }

    .MuiOutlinedInput-root {
      box-shadow: 0 0 0 4px transparent;
      gap: 6px;
      padding: 11px 14px;

      fieldset {
        border-radius: 8px;
        border: ${e ? "none" : `1px solid ${n ? r.palette.success[500] : r.palette.grey[300]}`};
      }

      &.Mui-disabled fieldset {
        border-color: ${r.palette.grey[300]};
      }

      &:hover:not(.Mui-disabled) fieldset {
        border: ${e ? "none" : `1px solid ${r.palette.grey[300]}`};
      }

      &.Mui-focused fieldset {
        border: ${e ? "none" : `1px solid ${r.palette.grey[300]}`};
        box-shadow: 0 0 0 4px ${r.palette.primary[100]};
      }

      .MuiOutlinedInput-input {
        padding: 0;
        color: ${r.palette.grey[900]};

        &::placeholder {
          ${Re("body-1")}
          color: ${r.palette.grey[500]};
          opacity: 1;
        }

        &.MuiInputBase-inputAdornedStart {
          padding-left: 0;
        }
      }
    }

    .Mui-error .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${r.palette.error[300]};
    }

    .Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${r.palette.error[300]};
      box-shadow: 0 0 0 4px ${r.palette.error[100]};
    }

    &:hover .Mui-error .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${r.palette.error[300]};
    }

    .MuiFormHelperText-root {
      ${Re("body-2")}
      margin: 8px 0 0;
      color: ${r.palette.grey[500]};

      &.Mui-error {
        color: ${r.palette.error[500]};
      }
    }

    .Mui-disabled .MuiSvgIcon-root {
      color: ${r.palette.grey[200]};
    }
  `), $d = /* @__PURE__ */ ye(({ label: e, startAdornment: r, showEndAdornmentOnError: t = !0, ...n }, o) => {
  const i = {
    ...n,
    ...r ? {
      InputProps: {
        startAdornment: r
      }
    } : {},
    ...n.success && {
      InputProps: {
        endAdornment: /* @__PURE__ */ u(Qe, {
          position: "end",
          children: /* @__PURE__ */ u(ai, {
            color: "success"
          })
        })
      }
    },
    ...n.error && t ? {
      InputProps: {
        endAdornment: /* @__PURE__ */ u(Qe, {
          position: "end",
          children: /* @__PURE__ */ u(si, {
            color: "error"
          })
        })
      }
    } : {}
  };
  return /* @__PURE__ */ u(Ci, {
    ...i,
    variant: "outlined",
    ref: o
  });
}), Oi = {
  size: "small",
  state: "base"
}, Pi = (e = "small") => ({
  small: {
    sizeContainer: 16,
    borderRadius: 4,
    iconSize: 12
  },
  medium: {
    sizeContainer: 20,
    borderRadius: 6,
    iconSize: 14
  }
})[e || Oi.size], jt = (e) => {
  const { sizeContainer: r, iconSize: t, borderRadius: n } = Pi(e);
  return d`
    ${be(r)};
    border-radius: ${n}px;

    svg {
      ${be(t)};
    }
  `;
}, Mi = (e) => d`
    border: 1px solid ${e.palette.grey[300]};
    background-color: ${e.palette.common.white};

    display: flex;
    align-items: center;
    justify-content: center;

    transition:
      border-color 0.2s,
      background-color 0.2s;
  `, Ai = (e) => d`
    padding: 0;
    border-radius: 0;

    &.${sr.checked}, &.${sr.indeterminate} {
      .${qe.root} {
        border: 1px solid ${e.palette.primary[600]};
        background-color: ${e.palette.primary[50]};
        color: ${e.palette.primary[600]};
      }
    }

    &.${sr.sizeSmall} {
      .${qe.root} {
        ${jt("small")};
      }
    }

    &.${sr.sizeMedium} {
      .${qe.root} {
        ${jt("medium")};
      }
    }

    &:hover {
      .${qe.root} {
        background-color: ${e.palette.primary[100]};
        border-color: ${e.palette.primary[600]};
      }
    }

    &:focus,
    &.${It.focusVisible} {
      .${qe.root} {
        box-shadow: 0 0 0 4px ${e.palette.primary[100]};
        border-color: ${e.palette.primary[300]};
      }

      &.${sr.checked} {
        .${qe.root} {
          border-color: ${e.palette.primary[600]};
        }
      }
    }

    &.${It.disabled} {
      .${qe.root} {
       color: ${e.palette.grey[300]};
        border-color: ${e.palette.grey[300]};
        background-color: ${e.palette.grey[100]};
      }
  `, Kr = /* @__PURE__ */ $(re, {
  target: "eei6vp70"
})(({ theme: e }) => d`
    ${Mi(e)};
  `), Ri = /* @__PURE__ */ $(xo, {
  target: "eei6vp71"
})(({ theme: e, size: r }) => d`
    ${Ai(e)};
  `), vd = /* @__PURE__ */ ye(({ className: e, ...r }, t) => /* @__PURE__ */ u(Ri, {
  icon: /* @__PURE__ */ u(Kr, {}),
  checkedIcon: /* @__PURE__ */ u(Kr, {
    children: /* @__PURE__ */ u(ci, {})
  }),
  indeterminateIcon: /* @__PURE__ */ u(Kr, {
    children: /* @__PURE__ */ u(li, {})
  }),
  disableRipple: !0,
  ref: t,
  ...r
})), Dn = /* @__PURE__ */ $("span", {
  target: "e1iiw7p80"
})(({ theme: e }) => d`
    border-radius: 50%;
    width: 100%;
    height: 100%;
    background-color: ${e.palette.common.white};
    border: 1px solid ${e.palette.grey[300]};
    transition: all 100ms ease-in-out;

    .Mui-focusVisible & {
      outline: ${e.palette.primary[100]} solid 4px;
    }

    input:hover ~ & {
      background-color: ${e.palette.primary[100]};
      border: 1px solid ${e.palette.primary[600]};
    }

    input:disabled ~ & {
      box-shadow: none;
      background-color: ${e.palette.grey[100]};
      border: 1px solid ${e.palette.grey[300]};

      &::before {
        background-color: ${e.palette.grey[300]};
      }
    }
  `), Ii = /* @__PURE__ */ $(Dn, {
  target: "e1iiw7p81"
})(({ theme: e, size: r = "medium" }) => d`
    background-color: ${e.palette.primary[100]};
    border: 1px solid ${e.palette.primary[600]};

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      background-color: ${e.palette.primary[600]};

      ${r === "small" && d`
        width: 6px;
        height: 6px;
      `}

      ${r === "medium" && d`
        width: 8px;
        height: 8px;
      `}
    }
  `), zi = /* @__PURE__ */ $($o, {
  target: "e1iiw7p82"
})(({ size: e = "medium" }) => d`
    padding: 0;

    ${e === "medium" && d`
      width: 20px;
      height: 20px;
    `}

    ${e === "small" && d`
      width: 16px;
      height: 16px;
    `}
  `), Sd = /* @__PURE__ */ ye((e, r) => /* @__PURE__ */ u(zi, {
  checkedIcon: /* @__PURE__ */ u(Ii, {
    size: e.size
  }),
  icon: /* @__PURE__ */ u(Dn, {}),
  ...e,
  ref: r
})), Fi = /* @__PURE__ */ $(vo, ve, {
  target: "e1l2tc650"
})(({ theme: e, $disableBackground: r, $disableFixSizeIcon: t }) => d`
    color: ${e.palette.grey[500]};

    &:disabled {
      color: ${e.palette.grey[300]};
    }

    /** TODO: In the future the code may not be needed, for now a temporary solution */
    ${!t && d`
      svg {
        ${be(24)};
      }

      &:disabled {
        path {
          stroke: ${e.palette.grey[300]};
        }
      }
    `}

    ${r && d`
      padding: 0;

      &:hover {
        background: none;
      }
    `}
  `), $t = /* @__PURE__ */ ye(({ children: e, disableBackground: r, disableFixSizeIcon: t, size: n = "small", ...o }, i) => /* @__PURE__ */ u(Fi, {
  ref: i,
  size: n,
  $disableBackground: r,
  $disableFixSizeIcon: t,
  ...o,
  children: e
})), Ve = {
  variant: "primary",
  size: "md"
}, Di = (e, r = Ve.variant) => {
  const t = {
    primary: {
      color: e.palette.common.white,
      background: e.palette.primary[600],
      border: `1px solid ${e.palette.primary[600]}`,
      boxShadow: e.customShadows.xs,
      hover: {
        background: e.palette.primary[700],
        border: `1px solid ${e.palette.primary[700]}`
      },
      focus: {
        background: e.palette.primary[600],
        color: e.palette.common.white
      },
      disabled: {
        background: e.palette.primary[200],
        color: e.palette.common.white,
        border: `1px solid ${e.palette.primary[200]}`
      }
    },
    secondary: {
      color: e.palette.primary[700],
      background: e.palette.primary[50],
      border: `1px solid ${e.palette.primary[500]}`,
      hover: {
        background: e.palette.primary[100],
        color: e.palette.primary[800]
      },
      focus: {
        background: e.palette.primary[50],
        color: e.palette.primary[800]
      },
      disabled: {
        background: e.palette.primary[25],
        color: e.palette.primary[300],
        border: `1px solid ${e.palette.primary[200]}`
      }
    },
    alert: {
      color: e.palette.error[700],
      background: e.palette.common.white,
      border: `1px solid ${e.palette.error[300]}`,
      boxShadow: e.customShadows.xs,
      hover: {
        color: e.palette.error[800],
        background: e.palette.error[50],
        border: `1px solid ${e.palette.error[300]}`
      },
      focus: {
        color: e.palette.error[800],
        background: e.palette.common.white
      },
      disabled: {
        color: e.palette.error[300],
        background: e.palette.common.white,
        border: `1px solid ${e.palette.error[200]}`
      }
    },
    error: {
      background: e.palette.error[600],
      color: e.palette.common.white,
      border: `1px solid ${e.palette.error[600]}`,
      boxShadow: e.customShadows.xs,
      hover: {
        background: e.palette.error[700],
        border: `1px solid ${e.palette.error[700]}`
      },
      focus: {
        background: e.palette.error[600],
        color: e.palette.common.white
      },
      disabled: {
        background: e.palette.error[200],
        color: e.palette.common.white,
        border: `1px solid ${e.palette.error[200]}`
      }
    },
    outlined: {
      color: e.palette.grey[700],
      background: e.palette.common.white,
      border: `1px solid ${e.palette.grey[300]}`,
      boxShadow: e.customShadows.xs,
      hover: {
        color: e.palette.grey[800],
        background: e.palette.grey[50],
        border: `1px solid ${e.palette.grey[300]}`
      },
      focus: {
        border: `1px solid ${e.palette.grey[300]}`,
        color: e.palette.grey[700]
      },
      disabled: {
        color: e.palette.grey[300],
        border: `1px solid ${e.palette.grey[200]}`
      },
      active: {
        color: e.palette.grey[800],
        background: e.palette.grey[100],
        border: `1px solid ${e.palette.grey[300]}`
      }
    },
    info: {
      color: e.palette.primary[700]
    },
    link: {
      color: e.palette.primary[700],
      hover: {
        background: "transparent",
        color: e.palette.primary[800]
      },
      focus: {
        background: "transparent",
        color: e.palette.primary[700]
      },
      disabled: {
        color: e.palette.grey[300],
        background: "transparent"
      }
    },
    text: {
      color: e.palette.grey[500],
      hover: {
        background: "transparent",
        color: e.palette.grey[600]
      },
      focus: {
        background: "transparent",
        color: e.palette.grey[500]
      },
      disabled: {
        color: e.palette.grey[300],
        background: "transparent"
      }
    }
  };
  return (t == null ? void 0 : t[r]) || (t == null ? void 0 : t[Ve.variant]);
}, ji = (e, r = "md") => {
  const t = {
    xs: {
      font: e.typography["caption-1-md"],
      padding: "3px 12px",
      borderRadius: "6px",
      iconMargin: "8px",
      iconSize: "16px",
      minHeight: "24px",
      paddingIcon: "3px"
    },
    sm: {
      font: e.typography["body-2-md"],
      padding: "7px 14px",
      borderRadius: "8px",
      iconSize: "20px",
      minHeight: "36px",
      paddingIcon: "7px"
    },
    md: {
      font: e.typography["body-2-md"],
      padding: "9px 16px",
      borderRadius: "8px",
      iconSize: "20px",
      minHeight: "40px",
      paddingIcon: "9px"
    },
    lg: {
      font: e.typography["body-1-md"],
      padding: "11px 18px",
      borderRadius: "8px",
      iconSize: "20px",
      minHeight: "44px",
      paddingIcon: "11px"
    },
    xl: {
      font: e.typography["body-1-md"],
      padding: "13px 20px",
      borderRadius: "8px",
      iconSize: "20px",
      minHeight: "48px",
      paddingIcon: "13px"
    },
    "2xl": {
      font: e.typography["title-4-md"],
      padding: "18px 28px",
      borderRadius: "8px",
      iconMargin: "12px",
      iconSize: "24px",
      minHeight: "60px",
      paddingIcon: "17px"
    }
  };
  return t[r] || t[Ve.size];
}, Ni = wn`
  0%, 100% { background-position: 100% 100%; }
  50% { background-position: 200% 100%; }
`, Li = (e) => d`
    text-transform: none;
    font-family: ${xt};

    ${e && d`
      background-image: linear-gradient(
        30deg,
        transparent,
        transparent 10%,
        rgba(255, 255, 255, 0.15) 15%,
        transparent 20%,
        transparent
      );
      background-size: 300% 300%;
      animation: ${Ni} 3s ease-in-out infinite reverse;
    `};
  `, Bi = (e, r, t) => {
  const { font: n, padding: o, borderRadius: i, iconSize: a, iconMargin: s, minHeight: c, paddingIcon: l } = ji(ae, e);
  return d`
    font-size: ${n == null ? void 0 : n.fontSize}px;
    line-height: ${n == null ? void 0 : n.lineHeight};
    font-weight: ${n == null ? void 0 : n.fontWeight};
    padding: ${o};
    border-radius: ${i};
    min-height: ${c};

    ${r && d`
      padding: ${t ? 0 : l};
      min-width: 0;
    `}

    .MuiButton-startIcon {
      ${r && d`
        margin: 0;
      `}

      ${!r && s && d`
        margin-right: ${s};
      `}
    }

    .MuiButton-endIcon {
      ${r && d`
        margin: auto;
      `}

      ${!r && s && d`
        margin-left: ${s};
      `}
    }

    .MuiButton-icon {
      font-size: ${a};

      .MuiCircularProgress-root {
        width: ${a} !important;
        height: ${a} !important;
      }

      svg {
        width: ${a};
        height: ${a};
      }
    }

    ${t && d`
      min-width: 0;
      min-height: 0;
      padding: 0;
    `}
  `;
}, Wi = (e) => {
  const { color: r, background: t, border: n, boxShadow: o, hover: i, focus: a, disabled: s, active: c } = Di(ae, e);
  return d`
    color: ${r};
    background: ${t};
    border: ${n};
    box-shadow: ${o};

    .MuiButton-icon svg {
      transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1);
      color: ${r};
    }

    &:hover {
      background: ${i == null ? void 0 : i.background};
      border: ${i == null ? void 0 : i.border};
      color: ${i == null ? void 0 : i.color};

      .MuiButton-icon svg {
        color: ${i == null ? void 0 : i.color};
      }
    }

    &:focus {
      background: ${a == null ? void 0 : a.background};
      border: ${a == null ? void 0 : a.border};
      color: ${a == null ? void 0 : a.color};
      box-shadow: ${a == null ? void 0 : a.boxShadow};

      .MuiButton-icon svg {
        color: ${a == null ? void 0 : a.color};
      }
    }

    &[aria-pressed='true'] {
      background: ${c == null ? void 0 : c.background};
      border: ${c == null ? void 0 : c.border};
      color: ${c == null ? void 0 : c.color};

      .MuiButton-icon svg {
        color: ${c == null ? void 0 : c.color};
      }
    }

    &:disabled {
      background: ${s == null ? void 0 : s.background};
      border: ${s == null ? void 0 : s.border};
      color: ${s == null ? void 0 : s.color};

      .MuiButton-icon svg {
        color: ${s == null ? void 0 : s.color};
      }
    }
  `;
}, qi = /* @__PURE__ */ $(So, ve, {
  target: "ejazso00"
})(({ $size: e = Ve.size, $variant: r = Ve.variant, $isAnimatedBackground: t = !1, $noChildren: n = !1, $noPadding: o = !1 }) => d`
    ${Bi(e, n, o)};
    ${Wi(r)};
    ${Li(t)};
  `), it = /* @__PURE__ */ ye(({ isLoading: e, variant: r = Ve.variant, isAnimatedBackground: t, startIcon: n, size: o = Ve.size, children: i, disableRipple: a = !0, disableElevation: s = !0, noPadding: c = !1, disabled: l = !1, ...p }, h) => /* @__PURE__ */ u(qi, {
  ref: h,
  $variant: r,
  $isAnimatedBackground: t,
  $size: o,
  startIcon: e ? /* @__PURE__ */ u(dr, {}) : n,
  $noChildren: !i,
  $noPadding: c,
  disableRipple: a,
  disableElevation: s,
  disabled: e || l,
  ...p,
  children: i && /* @__PURE__ */ u("span", {
    children: i
  })
})), Vi = () => d`
  display: inline-flex;
  border-radius: 8px;
`, Ui = (e) => {
  const r = e === "horizontal" ? "row" : "column";
  return e === "vertical" ? d`
      flex-direction: ${r};

      & > *:first-of-type {
        border-radius: 8px 8px 0 0;
      }

      & > *:last-of-type {
        border-radius: 0 0 8px 8px;
      }

      & > *:not(:first-of-type):not(:last-of-type) {
        border-radius: 0;
      }

      & > *:not(:first-of-type) {
        margin-top: -1px;
      }

      & > *:not(:last-of-type) {
        border-bottom-color: transparent;
      }
    ` : d`
    flex-direction: ${r};

    & > *:first-of-type {
      border-radius: 8px 0 0 8px;
    }

    & > *:last-of-type {
      border-radius: 0 8px 8px 0;
    }

    & > *:not(:first-of-type):not(:last-of-type) {
      border-radius: 0;
    }

    & > *:not(:first-of-type) {
      margin-left: -1px;
    }

    & > *:not(:last-of-type) {
      border-right-color: transparent;
    }
  `;
}, Hi = /* @__PURE__ */ $("div", {
  target: "e1bp68fb0"
})(({ $orientation: e }) => d`
    ${Vi()}
    ${Ui(e)}
  `), wd = ({ children: e, activeIndex: r, disabled: t = !1, size: n = "md", orientation: o = "horizontal", variant: i = "outlined", onClick: a }) => {
  const s = ei.toArray(e).filter((l) => /* @__PURE__ */ ri(l) && l.type === it), c = s.length;
  return /* @__PURE__ */ u(Hi, {
    role: "group",
    $orientation: o,
    $count: c,
    children: s.map((l, p) => /* @__PURE__ */ Cn(l, {
      variant: i,
      size: n,
      disabled: t || l.props.disabled,
      "aria-pressed": r === p,
      onClick: () => a == null ? void 0 : a(p)
    }))
  });
}, at = /* @__PURE__ */ ye(({ color: e = "inherit", stroke: r = "none", size: t = 20, width: n, height: o, component: i, ...a }, s) => {
  const c = e !== "inherit" ? Dt(e) : e, l = r !== "inherit" && r !== "none" ? Dt(r) : r;
  return /* @__PURE__ */ Cn(i, {
    color: c,
    stroke: l,
    width: n ?? t,
    height: o ?? t,
    ...a,
    ref: s
  });
}), Yi = /* @__PURE__ */ $(wo, {
  target: "e17dnjbh0"
})(({ max: e = 5 }) => d`
    .${ko.icon} {
      margin-right: 6px;
    }

    label:nth-of-type(${e}) span {
      margin-right: 6px;
    }
  `), kd = /* @__PURE__ */ ye(({ emptyIcon: e = /* @__PURE__ */ u(at, {
  component: /* @__PURE__ */ u(Ft, {}),
  size: 24,
  color: "common.white",
  stroke: "grey.400"
}), icon: r = /* @__PURE__ */ u(at, {
  component: /* @__PURE__ */ u(Ft, {}),
  size: 24,
  color: "primary.700",
  stroke: "primary.700"
}), ...t }, n) => /* @__PURE__ */ u(Yi, {
  emptyIcon: e,
  icon: r,
  ref: n,
  ...t
})), Ki = /* @__PURE__ */ $(To, {
  target: "e1jgm1q80"
})(({ min: e, max: r, theme: t }) => d`
    padding: 10px 0;
    box-sizing: border-box;

    .MuiSlider-thumb {
      height: 20px;
      width: 20px;
      border-radius: 10px;
      background-color: ${t.palette.common.white};
      box-shadow:
        0px 3.333px 6.667px -1.667px rgba(16, 24, 40, 0.1),
        0px 1.667px 3.333px -1.667px rgba(16, 24, 40, 0.06);
      transition: none;

      &:focus,
      &:hover,
      &.Mui-active,
      &.Mui-focusVisible {
        box-shadow: none;
      }
    }

    .MuiSlider-rail {
      background-color: ${t.palette.grey[300]};
      opacity: 1;
      height: 4px;
    }

    .MuiSlider-track {
      height: 4px;
      background-color: ${t.palette.primary[600]};
      border: none;
      transition: none;
    }

    .MuiSlider-mark {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${t.palette.grey[300]};
      transform: translate(-50%, -50%);
      opacity: 1;

      &[data-index='${e}'] {
        transform: translate(0, -50%);
      }

      &[data-index='${r}'] {
        transform: translate(-100%, -50%);
      }
    }

    .MuiSlider-markActive {
      background-color: ${t.palette.primary[600]};
    }

    &.Mui-disabled > :is(.MuiSlider-track, .MuiSlider-markActive) {
      background-color: ${t.palette.primary[300]};
    }
  `), Td = /* @__PURE__ */ ye((e, r) => /* @__PURE__ */ u(Ki, {
  ...e,
  ref: r
})), Gi = ({ success: e, error: r, disabled: t }) => t ? ae.palette.grey[300] : r ? ae.palette.error[500] : e ? ae.palette.success[500] : "inherit", Xi = ({ value: e, success: r, error: t, borderless: n }) => d`
    ${Re("body-1")}
    color: ${ae.palette.grey[e ? 900 : 500]};
    gap: 8px;
    padding: 0;
    border-radius: 8px;
    border: 1px solid ${r ? ae.palette.success[500] : ae.palette.grey[300]};

    ${n && d`
      border: none;
    `}

    &.${Ae.disabled} {
      color: ${ae.palette.grey[300]};
      border-color: ${ae.palette.grey[200]};
    }

    &.${Ae.error} {
      border-color: ${ae.palette.error[300]};
    }

    &.${Ae.focused} {
      box-shadow: 0 0 0 4px ${t ? ae.palette.error[100] : ae.palette.primary[100]};
    }
  `, Ji = (e) => d`
    &.${Ae.root} {
      .${Ae.input} {
        padding: 11px 14px;
        height: 22px;
        min-height: 22px;

        &::placeholder {
          color: ${ae.palette.grey[500]};
          opacity: 1;
        }
      }

      .${Ae.inputSizeSmall} {
        padding: 8px 12px;
      }

      .${Ae.inputAdornedStart} {
        padding-left: 0px;
      }

      .${Ae.inputAdornedEnd} {
        padding-right: 0px;
      }

      .${ot.positionStart} {
        padding-left: ${e === "small" ? 12 : 14}px;
      }

      .${ot.positionEnd} {
        padding-right: ${e === "small" ? 12 : 14}px;
      }
    }
  `, Zi = ({ success: e, error: r, disabled: t }) => d`
    &.${Ae.root} {
      .${ot.root} {
        color: ${Gi({
  success: e,
  error: r,
  disabled: t
})};
        margin: 0;
      }
    }
  `, Qi = /* @__PURE__ */ $(Eo, ve, {
  target: "e3mipye0"
})(({ $borderless: e, $success: r, error: t, disabled: n, value: o, size: i }) => d`
    ${Xi({
  success: r,
  borderless: e,
  error: t,
  value: o
})}
    ${Ji(i)}
    ${Zi({
  success: r,
  error: t,
  disabled: n
})}
  `), ea = /* @__PURE__ */ ye(({ borderless: e = !1, success: r = !1, showEndIconOnError: t = !0, startIcon: n, endIcon: o, ...i }, a) => {
  const s = {
    fullWidth: !0,
    ...i,
    ...n && {
      startAdornment: /* @__PURE__ */ u(Qe, {
        position: "start",
        children: n
      })
    },
    ...o && {
      endAdornment: /* @__PURE__ */ u(Qe, {
        position: "end",
        children: o
      })
    },
    ...r && {
      endAdornment: /* @__PURE__ */ u(Qe, {
        position: "end",
        children: /* @__PURE__ */ u(Pn, {
          width: 16,
          height: 16
        })
      })
    },
    ...i.error && t ? {
      endAdornment: /* @__PURE__ */ u(Qe, {
        position: "end",
        children: /* @__PURE__ */ u(ui, {
          width: 16,
          height: 16
        })
      })
    } : {}
  };
  return /* @__PURE__ */ u(Qi, {
    ...s,
    ref: a,
    $borderless: e,
    $success: r,
    disableUnderline: !0
  });
}), ra = /* @__PURE__ */ $(Ee, {
  shouldForwardProp: (e) => e !== "maxLines",
  target: "e1kcvw390"
})(({ maxLines: e }) => d`
    ${e === 1 && In};
    ${e && e > 1 && zn(e)};
  `), Ie = /* @__PURE__ */ ye((e, r) => /* @__PURE__ */ u(ra, {
  ...e,
  ref: r
})), ta = /* @__PURE__ */ $(_o, {
  target: "e1l71wen0"
})(() => d`
    .${Co.icon} {
      width: 16px;
      height: 16px;
    }
  `), na = /* @__PURE__ */ $(yt, {
  target: "e1l71wen1"
})(({ theme: e }) => d`
    min-height: 42px;
    padding: 11px 14px;
    justify-content: space-between;

    &.${Er.selected}, &.${Er.focusVisible}, &:hover,
    &:hover.${Er.selected} {
      background-color: ${e.palette.grey[50]};
    }
  `), oa = ({ selected: e, options: r, placeholder: t = "Choose", multiple: n = !1, renderComponent: o }) => {
  if (e == null || Array.isArray(e) && e.length === 0 || e === "")
    return /* @__PURE__ */ u(Ie, {
      variant: "body-1",
      color: "grey.500",
      children: t
    });
  if (n && Array.isArray(e))
    return e.map((s) => {
      const c = r == null ? void 0 : r.find((l) => l.value === s);
      return c ? c.label : String(s);
    }).join(", ");
  const i = r == null ? void 0 : r.find((s) => s.value === e), a = i ? i.label : String(e);
  return o ? o(a) : a;
}, Ed = /* @__PURE__ */ ye(({ children: e, isMenuInModal: r, menuVariant: t = "default", options: n, borderless: o, ...i }, a) => {
  const s = ti((c) => oa({
    selected: c,
    options: n,
    placeholder: i.placeholder,
    multiple: i.multiple
  }), [
    n,
    i.placeholder,
    i.multiple
  ]);
  return /* @__PURE__ */ u(ta, {
    input: /* @__PURE__ */ u(ea, {
      showEndIconOnError: !1,
      borderless: o
    }),
    ref: a,
    renderValue: s,
    IconComponent: di,
    notched: void 0,
    fullWidth: !0,
    displayEmpty: !0,
    MenuProps: {
      sx: (c) => ({
        zIndex: r ? c.zIndex.dialog : c.zIndex.popover
      }),
      PaperProps: {
        sx: (c) => ({
          borderRadius: 8,
          border: `1px solid ${c.palette.grey[300]}`,
          boxShadow: c.customShadows.lg,
          marginTop: 6,
          maxHeight: 400,
          ...t === "indented" ? {
            "& .MuiMenu-list": {
              padding: 4
            }
          } : {}
        })
      }
    },
    ...i,
    children: e
  });
}), _d = ({ children: e, ...r }) => /* @__PURE__ */ Y(na, {
  ...r,
  children: [
    /* @__PURE__ */ u(Ie, {
      variant: "body-1",
      color: "grey.900",
      children: e
    }),
    r.selected && /* @__PURE__ */ u(at, {
      component: /* @__PURE__ */ u(Pn, {}),
      width: 20,
      height: 20,
      color: "primary.600"
    })
  ]
}), ia = ({ children: e, ...r }) => /* @__PURE__ */ u(Oo, {
  sx: {
    lineHeight: "24px"
  },
  ...r,
  children: /* @__PURE__ */ u(Ie, {
    variant: "caption-1-md",
    color: "grey.700",
    children: e
  })
});
ia.muiSkipListHighlight = !0;
const Nt = {
  secondary: "grey",
  error: "error",
  warning: "warning",
  success: "success",
  primary: "primary"
}, aa = ({ palette: e }, r) => e[Nt[r] || Nt.primary], sa = (e, r, t) => {
  const n = aa(e, r);
  return d`
    background-color: ${t ? n[50] : e.palette.common.white};
    color: ${n[700]};

    > span {
      color: currentColor;
    }

    > svg,
    .${kn.root} {
      color: ${n[500]};
    }
  `;
}, ca = d`
  border-radius: 4px;
`, la = d`
  border-radius: 16px;
`, Lt = {
  squared: ca,
  rounded: la
}, ua = (e) => Lt[e] || Lt.rounded, Bt = /* @__PURE__ */ $(ge, ve, {
  target: "e7kzc240"
})(({ theme: e, $variant: r, $color: t, $isColoredBg: n, $isCircleChip: o = !1 }) => d`
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 6px;
    width: fit-content;
    height: 20px;
    padding: 2px 8px;
    white-space: nowrap;

    ${sa(e, t, n)};
    ${ua(r)}

    & > svg {
      width: ${o ? 16 : 12}px;
      height: ${o ? 16 : 12}px;
      flex-shrink: 0;
    }

    & > svg,
    .${kn.root} {
      margin: 0 -${o ? 4 : 2}px;
    }

    ${o && d`
      min-width: 20px;
      padding: 2px;
    `}
  `), Cd = /* @__PURE__ */ ye(({ label: e, icon: r, deleteIcon: t, color: n = "primary", variant: o = "rounded", isColoredBg: i = !0, isLoading: a = !1, ...s }, c) => (r || a) && !e ? /* @__PURE__ */ u(Bt, {
  ref: c,
  $variant: o,
  $color: n,
  $isColoredBg: i,
  $isCircleChip: !0,
  ...s,
  children: a ? /* @__PURE__ */ u(dr, {
    size: 16
  }) : r
}) : /* @__PURE__ */ Y(Bt, {
  ref: c,
  $variant: o,
  $isColoredBg: i,
  $color: n,
  ...s,
  children: [
    a ? /* @__PURE__ */ u(dr, {
      size: 12
    }) : r,
    /* @__PURE__ */ u(Ie, {
      variant: "caption-1-md",
      children: e
    }),
    t
  ]
}));
function pr(e) {
  let r = "https://mui.com/production-error/?code=" + e;
  for (let t = 1; t < arguments.length; t += 1)
    r += "&args[]=" + encodeURIComponent(arguments[t]);
  return "Minified MUI error #" + e + "; visit " + r + " for the full message.";
}
const da = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pr
}, Symbol.toStringTag, { value: "Module" })), pa = "$$material";
function X() {
  return X = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, X.apply(this, arguments);
}
function Ue(e, r) {
  if (e == null) return {};
  var t = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(r.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
function fa(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ne(e) {
  if (e.__esModule) return e;
  var r = e.default;
  if (typeof r == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    t.prototype = r.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), t;
}
var st = { exports: {} }, wr = { exports: {} }, W = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wt;
function ga() {
  if (Wt) return W;
  Wt = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, x = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
  function C(y) {
    if (typeof y == "object" && y !== null) {
      var B = y.$$typeof;
      switch (B) {
        case r:
          switch (y = y.type, y) {
            case c:
            case l:
            case n:
            case i:
            case o:
            case h:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case p:
                case x:
                case S:
                case a:
                  return y;
                default:
                  return B;
              }
          }
        case t:
          return B;
      }
    }
  }
  function D(y) {
    return C(y) === l;
  }
  return W.AsyncMode = c, W.ConcurrentMode = l, W.ContextConsumer = s, W.ContextProvider = a, W.Element = r, W.ForwardRef = p, W.Fragment = n, W.Lazy = x, W.Memo = S, W.Portal = t, W.Profiler = i, W.StrictMode = o, W.Suspense = h, W.isAsyncMode = function(y) {
    return D(y) || C(y) === c;
  }, W.isConcurrentMode = D, W.isContextConsumer = function(y) {
    return C(y) === s;
  }, W.isContextProvider = function(y) {
    return C(y) === a;
  }, W.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === r;
  }, W.isForwardRef = function(y) {
    return C(y) === p;
  }, W.isFragment = function(y) {
    return C(y) === n;
  }, W.isLazy = function(y) {
    return C(y) === x;
  }, W.isMemo = function(y) {
    return C(y) === S;
  }, W.isPortal = function(y) {
    return C(y) === t;
  }, W.isProfiler = function(y) {
    return C(y) === i;
  }, W.isStrictMode = function(y) {
    return C(y) === o;
  }, W.isSuspense = function(y) {
    return C(y) === h;
  }, W.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === l || y === i || y === o || y === h || y === b || typeof y == "object" && y !== null && (y.$$typeof === x || y.$$typeof === S || y.$$typeof === a || y.$$typeof === s || y.$$typeof === p || y.$$typeof === g || y.$$typeof === k || y.$$typeof === M || y.$$typeof === f);
  }, W.typeOf = C, W;
}
var q = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qt;
function ba() {
  return qt || (qt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, x = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
    function C(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === n || v === l || v === i || v === o || v === h || v === b || typeof v == "object" && v !== null && (v.$$typeof === x || v.$$typeof === S || v.$$typeof === a || v.$$typeof === s || v.$$typeof === p || v.$$typeof === g || v.$$typeof === k || v.$$typeof === M || v.$$typeof === f);
    }
    function D(v) {
      if (typeof v == "object" && v !== null) {
        var he = v.$$typeof;
        switch (he) {
          case r:
            var T = v.type;
            switch (T) {
              case c:
              case l:
              case n:
              case i:
              case o:
              case h:
                return T;
              default:
                var Ye = T && T.$$typeof;
                switch (Ye) {
                  case s:
                  case p:
                  case x:
                  case S:
                  case a:
                    return Ye;
                  default:
                    return he;
                }
            }
          case t:
            return he;
        }
      }
    }
    var y = c, B = l, R = s, we = a, Fe = r, Oe = p, J = n, ne = x, ke = S, ue = t, Be = i, se = o, Pe = h, We = !1;
    function He(v) {
      return We || (We = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), m(v) || D(v) === c;
    }
    function m(v) {
      return D(v) === l;
    }
    function w(v) {
      return D(v) === s;
    }
    function A(v) {
      return D(v) === a;
    }
    function O(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function E(v) {
      return D(v) === p;
    }
    function I(v) {
      return D(v) === n;
    }
    function _(v) {
      return D(v) === x;
    }
    function P(v) {
      return D(v) === S;
    }
    function z(v) {
      return D(v) === t;
    }
    function j(v) {
      return D(v) === i;
    }
    function F(v) {
      return D(v) === o;
    }
    function oe(v) {
      return D(v) === h;
    }
    q.AsyncMode = y, q.ConcurrentMode = B, q.ContextConsumer = R, q.ContextProvider = we, q.Element = Fe, q.ForwardRef = Oe, q.Fragment = J, q.Lazy = ne, q.Memo = ke, q.Portal = ue, q.Profiler = Be, q.StrictMode = se, q.Suspense = Pe, q.isAsyncMode = He, q.isConcurrentMode = m, q.isContextConsumer = w, q.isContextProvider = A, q.isElement = O, q.isForwardRef = E, q.isFragment = I, q.isLazy = _, q.isMemo = P, q.isPortal = z, q.isProfiler = j, q.isStrictMode = F, q.isSuspense = oe, q.isValidElementType = C, q.typeOf = D;
  }()), q;
}
var Vt;
function jn() {
  return Vt || (Vt = 1, process.env.NODE_ENV === "production" ? wr.exports = ga() : wr.exports = ba()), wr.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Gr, Ut;
function ya() {
  if (Ut) return Gr;
  Ut = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(p) {
        return a[p];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        l[p] = p;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Gr = o() ? Object.assign : function(i, a) {
    for (var s, c = n(i), l, p = 1; p < arguments.length; p++) {
      s = Object(arguments[p]);
      for (var h in s)
        r.call(s, h) && (c[h] = s[h]);
      if (e) {
        l = e(s);
        for (var b = 0; b < l.length; b++)
          t.call(s, l[b]) && (c[l[b]] = s[l[b]]);
      }
    }
    return c;
  }, Gr;
}
var Xr, Ht;
function vt() {
  if (Ht) return Xr;
  Ht = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Xr = e, Xr;
}
var Jr, Yt;
function Nn() {
  return Yt || (Yt = 1, Jr = Function.call.bind(Object.prototype.hasOwnProperty)), Jr;
}
var Zr, Kt;
function ha() {
  if (Kt) return Zr;
  Kt = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = vt(), t = {}, n = Nn();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in i)
        if (n(i, p)) {
          var h;
          try {
            if (typeof i[p] != "function") {
              var b = Error(
                (c || "React class") + ": " + s + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw b.name = "Invariant Violation", b;
            }
            h = i[p](a, p, c, s, null, r);
          } catch (x) {
            h = x;
          }
          if (h && !(h instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in t)) {
            t[h.message] = !0;
            var S = l ? l() : "";
            e(
              "Failed " + s + " type: " + h.message + (S ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Zr = o, Zr;
}
var Qr, Gt;
function ma() {
  if (Gt) return Qr;
  Gt = 1;
  var e = jn(), r = ya(), t = vt(), n = Nn(), o = ha(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Qr = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function h(m) {
      var w = m && (l && m[l] || m[p]);
      if (typeof w == "function")
        return w;
    }
    var b = "<<anonymous>>", S = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: M(),
      arrayOf: C,
      element: D(),
      elementType: y(),
      instanceOf: B,
      node: Oe(),
      objectOf: we,
      oneOf: R,
      oneOfType: Fe,
      shape: ne,
      exact: ke
    };
    function x(m, w) {
      return m === w ? m !== 0 || 1 / m === 1 / w : m !== m && w !== w;
    }
    function f(m, w) {
      this.message = m, this.data = w && typeof w == "object" ? w : {}, this.stack = "";
    }
    f.prototype = Error.prototype;
    function g(m) {
      if (process.env.NODE_ENV !== "production")
        var w = {}, A = 0;
      function O(I, _, P, z, j, F, oe) {
        if (z = z || b, F = F || P, oe !== t) {
          if (c) {
            var v = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw v.name = "Invariant Violation", v;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var he = z + ":" + P;
            !w[he] && // Avoid spamming the console because they are often not actionable except for lib authors
            A < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + F + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), w[he] = !0, A++);
          }
        }
        return _[P] == null ? I ? _[P] === null ? new f("The " + j + " `" + F + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new f("The " + j + " `" + F + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : m(_, P, z, j, F);
      }
      var E = O.bind(null, !1);
      return E.isRequired = O.bind(null, !0), E;
    }
    function k(m) {
      function w(A, O, E, I, _, P) {
        var z = A[O], j = se(z);
        if (j !== m) {
          var F = Pe(z);
          return new f(
            "Invalid " + I + " `" + _ + "` of type " + ("`" + F + "` supplied to `" + E + "`, expected ") + ("`" + m + "`."),
            { expectedType: m }
          );
        }
        return null;
      }
      return g(w);
    }
    function M() {
      return g(a);
    }
    function C(m) {
      function w(A, O, E, I, _) {
        if (typeof m != "function")
          return new f("Property `" + _ + "` of component `" + E + "` has invalid PropType notation inside arrayOf.");
        var P = A[O];
        if (!Array.isArray(P)) {
          var z = se(P);
          return new f("Invalid " + I + " `" + _ + "` of type " + ("`" + z + "` supplied to `" + E + "`, expected an array."));
        }
        for (var j = 0; j < P.length; j++) {
          var F = m(P, j, E, I, _ + "[" + j + "]", t);
          if (F instanceof Error)
            return F;
        }
        return null;
      }
      return g(w);
    }
    function D() {
      function m(w, A, O, E, I) {
        var _ = w[A];
        if (!s(_)) {
          var P = se(_);
          return new f("Invalid " + E + " `" + I + "` of type " + ("`" + P + "` supplied to `" + O + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(m);
    }
    function y() {
      function m(w, A, O, E, I) {
        var _ = w[A];
        if (!e.isValidElementType(_)) {
          var P = se(_);
          return new f("Invalid " + E + " `" + I + "` of type " + ("`" + P + "` supplied to `" + O + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(m);
    }
    function B(m) {
      function w(A, O, E, I, _) {
        if (!(A[O] instanceof m)) {
          var P = m.name || b, z = He(A[O]);
          return new f("Invalid " + I + " `" + _ + "` of type " + ("`" + z + "` supplied to `" + E + "`, expected ") + ("instance of `" + P + "`."));
        }
        return null;
      }
      return g(w);
    }
    function R(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function w(A, O, E, I, _) {
        for (var P = A[O], z = 0; z < m.length; z++)
          if (x(P, m[z]))
            return null;
        var j = JSON.stringify(m, function(oe, v) {
          var he = Pe(v);
          return he === "symbol" ? String(v) : v;
        });
        return new f("Invalid " + I + " `" + _ + "` of value `" + String(P) + "` " + ("supplied to `" + E + "`, expected one of " + j + "."));
      }
      return g(w);
    }
    function we(m) {
      function w(A, O, E, I, _) {
        if (typeof m != "function")
          return new f("Property `" + _ + "` of component `" + E + "` has invalid PropType notation inside objectOf.");
        var P = A[O], z = se(P);
        if (z !== "object")
          return new f("Invalid " + I + " `" + _ + "` of type " + ("`" + z + "` supplied to `" + E + "`, expected an object."));
        for (var j in P)
          if (n(P, j)) {
            var F = m(P, j, E, I, _ + "." + j, t);
            if (F instanceof Error)
              return F;
          }
        return null;
      }
      return g(w);
    }
    function Fe(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var w = 0; w < m.length; w++) {
        var A = m[w];
        if (typeof A != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + We(A) + " at index " + w + "."
          ), a;
      }
      function O(E, I, _, P, z) {
        for (var j = [], F = 0; F < m.length; F++) {
          var oe = m[F], v = oe(E, I, _, P, z, t);
          if (v == null)
            return null;
          v.data && n(v.data, "expectedType") && j.push(v.data.expectedType);
        }
        var he = j.length > 0 ? ", expected one of type [" + j.join(", ") + "]" : "";
        return new f("Invalid " + P + " `" + z + "` supplied to " + ("`" + _ + "`" + he + "."));
      }
      return g(O);
    }
    function Oe() {
      function m(w, A, O, E, I) {
        return ue(w[A]) ? null : new f("Invalid " + E + " `" + I + "` supplied to " + ("`" + O + "`, expected a ReactNode."));
      }
      return g(m);
    }
    function J(m, w, A, O, E) {
      return new f(
        (m || "React class") + ": " + w + " type `" + A + "." + O + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + E + "`."
      );
    }
    function ne(m) {
      function w(A, O, E, I, _) {
        var P = A[O], z = se(P);
        if (z !== "object")
          return new f("Invalid " + I + " `" + _ + "` of type `" + z + "` " + ("supplied to `" + E + "`, expected `object`."));
        for (var j in m) {
          var F = m[j];
          if (typeof F != "function")
            return J(E, I, _, j, Pe(F));
          var oe = F(P, j, E, I, _ + "." + j, t);
          if (oe)
            return oe;
        }
        return null;
      }
      return g(w);
    }
    function ke(m) {
      function w(A, O, E, I, _) {
        var P = A[O], z = se(P);
        if (z !== "object")
          return new f("Invalid " + I + " `" + _ + "` of type `" + z + "` " + ("supplied to `" + E + "`, expected `object`."));
        var j = r({}, A[O], m);
        for (var F in j) {
          var oe = m[F];
          if (n(m, F) && typeof oe != "function")
            return J(E, I, _, F, Pe(oe));
          if (!oe)
            return new f(
              "Invalid " + I + " `" + _ + "` key `" + F + "` supplied to `" + E + "`.\nBad object: " + JSON.stringify(A[O], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(m), null, "  ")
            );
          var v = oe(P, F, E, I, _ + "." + F, t);
          if (v)
            return v;
        }
        return null;
      }
      return g(w);
    }
    function ue(m) {
      switch (typeof m) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !m;
        case "object":
          if (Array.isArray(m))
            return m.every(ue);
          if (m === null || s(m))
            return !0;
          var w = h(m);
          if (w) {
            var A = w.call(m), O;
            if (w !== m.entries) {
              for (; !(O = A.next()).done; )
                if (!ue(O.value))
                  return !1;
            } else
              for (; !(O = A.next()).done; ) {
                var E = O.value;
                if (E && !ue(E[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Be(m, w) {
      return m === "symbol" ? !0 : w ? w["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && w instanceof Symbol : !1;
    }
    function se(m) {
      var w = typeof m;
      return Array.isArray(m) ? "array" : m instanceof RegExp ? "object" : Be(w, m) ? "symbol" : w;
    }
    function Pe(m) {
      if (typeof m > "u" || m === null)
        return "" + m;
      var w = se(m);
      if (w === "object") {
        if (m instanceof Date)
          return "date";
        if (m instanceof RegExp)
          return "regexp";
      }
      return w;
    }
    function We(m) {
      var w = Pe(m);
      switch (w) {
        case "array":
        case "object":
          return "an " + w;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + w;
        default:
          return w;
      }
    }
    function He(m) {
      return !m.constructor || !m.constructor.name ? b : m.constructor.name;
    }
    return S.checkPropTypes = o, S.resetWarningCache = o.resetWarningCache, S.PropTypes = S, S;
  }, Qr;
}
var et, Xt;
function xa() {
  if (Xt) return et;
  Xt = 1;
  var e = vt();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, et = function() {
    function n(a, s, c, l, p, h) {
      if (h !== e) {
        var b = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw b.name = "Invariant Violation", b;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return i.PropTypes = i, i;
  }, et;
}
if (process.env.NODE_ENV !== "production") {
  var $a = jn(), va = !0;
  st.exports = ma()($a.isElement, va);
} else
  st.exports = xa()();
var Sa = st.exports;
const de = /* @__PURE__ */ fa(Sa);
function wa(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function ka(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Ta = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(o) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, i), n.tags.push(o);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(ka(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var a = wa(o);
      try {
        a.insertRule(n, a.cssRules.length);
      } catch (s) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', s);
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), ie = "-ms-", Ar = "-moz-", N = "-webkit-", St = "comm", wt = "rule", kt = "decl", Ea = "@import", Ln = "@keyframes", _a = "@layer", Ca = Math.abs, Fr = String.fromCharCode, Oa = Object.assign;
function Pa(e, r) {
  return te(e, 0) ^ 45 ? (((r << 2 ^ te(e, 0)) << 2 ^ te(e, 1)) << 2 ^ te(e, 2)) << 2 ^ te(e, 3) : 0;
}
function Bn(e) {
  return e.trim();
}
function Ma(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function L(e, r, t) {
  return e.replace(r, t);
}
function ct(e, r) {
  return e.indexOf(r);
}
function te(e, r) {
  return e.charCodeAt(r) | 0;
}
function fr(e, r, t) {
  return e.slice(r, t);
}
function Te(e) {
  return e.length;
}
function Tt(e) {
  return e.length;
}
function kr(e, r) {
  return r.push(e), e;
}
function Aa(e, r) {
  return e.map(r).join("");
}
var Dr = 1, nr = 1, Wn = 0, le = 0, ee = 0, or = "";
function jr(e, r, t, n, o, i, a) {
  return { value: e, root: r, parent: t, type: n, props: o, children: i, line: Dr, column: nr, length: a, return: "" };
}
function cr(e, r) {
  return Oa(jr("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Ra() {
  return ee;
}
function Ia() {
  return ee = le > 0 ? te(or, --le) : 0, nr--, ee === 10 && (nr = 1, Dr--), ee;
}
function fe() {
  return ee = le < Wn ? te(or, le++) : 0, nr++, ee === 10 && (nr = 1, Dr++), ee;
}
function _e() {
  return te(or, le);
}
function _r() {
  return le;
}
function yr(e, r) {
  return fr(or, e, r);
}
function gr(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function qn(e) {
  return Dr = nr = 1, Wn = Te(or = e), le = 0, [];
}
function Vn(e) {
  return or = "", e;
}
function Cr(e) {
  return Bn(yr(le - 1, lt(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function za(e) {
  for (; (ee = _e()) && ee < 33; )
    fe();
  return gr(e) > 2 || gr(ee) > 3 ? "" : " ";
}
function Fa(e, r) {
  for (; --r && fe() && !(ee < 48 || ee > 102 || ee > 57 && ee < 65 || ee > 70 && ee < 97); )
    ;
  return yr(e, _r() + (r < 6 && _e() == 32 && fe() == 32));
}
function lt(e) {
  for (; fe(); )
    switch (ee) {
      case e:
        return le;
      case 34:
      case 39:
        e !== 34 && e !== 39 && lt(ee);
        break;
      case 40:
        e === 41 && lt(e);
        break;
      case 92:
        fe();
        break;
    }
  return le;
}
function Da(e, r) {
  for (; fe() && e + ee !== 57; )
    if (e + ee === 84 && _e() === 47)
      break;
  return "/*" + yr(r, le - 1) + "*" + Fr(e === 47 ? e : fe());
}
function ja(e) {
  for (; !gr(_e()); )
    fe();
  return yr(e, le);
}
function Na(e) {
  return Vn(Or("", null, null, null, [""], e = qn(e), 0, [0], e));
}
function Or(e, r, t, n, o, i, a, s, c) {
  for (var l = 0, p = 0, h = a, b = 0, S = 0, x = 0, f = 1, g = 1, k = 1, M = 0, C = "", D = o, y = i, B = n, R = C; g; )
    switch (x = M, M = fe()) {
      case 40:
        if (x != 108 && te(R, h - 1) == 58) {
          ct(R += L(Cr(M), "&", "&\f"), "&\f") != -1 && (k = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        R += Cr(M);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        R += za(x);
        break;
      case 92:
        R += Fa(_r() - 1, 7);
        continue;
      case 47:
        switch (_e()) {
          case 42:
          case 47:
            kr(La(Da(fe(), _r()), r, t), c);
            break;
          default:
            R += "/";
        }
        break;
      case 123 * f:
        s[l++] = Te(R) * k;
      case 125 * f:
      case 59:
      case 0:
        switch (M) {
          case 0:
          case 125:
            g = 0;
          case 59 + p:
            k == -1 && (R = L(R, /\f/g, "")), S > 0 && Te(R) - h && kr(S > 32 ? Zt(R + ";", n, t, h - 1) : Zt(L(R, " ", "") + ";", n, t, h - 2), c);
            break;
          case 59:
            R += ";";
          default:
            if (kr(B = Jt(R, r, t, l, p, o, s, C, D = [], y = [], h), i), M === 123)
              if (p === 0)
                Or(R, r, B, B, D, i, h, s, y);
              else
                switch (b === 99 && te(R, 3) === 110 ? 100 : b) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Or(e, B, B, n && kr(Jt(e, B, B, 0, 0, o, s, C, o, D = [], h), y), o, y, h, s, n ? D : y);
                    break;
                  default:
                    Or(R, B, B, B, [""], y, 0, s, y);
                }
        }
        l = p = S = 0, f = k = 1, C = R = "", h = a;
        break;
      case 58:
        h = 1 + Te(R), S = x;
      default:
        if (f < 1) {
          if (M == 123)
            --f;
          else if (M == 125 && f++ == 0 && Ia() == 125)
            continue;
        }
        switch (R += Fr(M), M * f) {
          case 38:
            k = p > 0 ? 1 : (R += "\f", -1);
            break;
          case 44:
            s[l++] = (Te(R) - 1) * k, k = 1;
            break;
          case 64:
            _e() === 45 && (R += Cr(fe())), b = _e(), p = h = Te(C = R += ja(_r())), M++;
            break;
          case 45:
            x === 45 && Te(R) == 2 && (f = 0);
        }
    }
  return i;
}
function Jt(e, r, t, n, o, i, a, s, c, l, p) {
  for (var h = o - 1, b = o === 0 ? i : [""], S = Tt(b), x = 0, f = 0, g = 0; x < n; ++x)
    for (var k = 0, M = fr(e, h + 1, h = Ca(f = a[x])), C = e; k < S; ++k)
      (C = Bn(f > 0 ? b[k] + " " + M : L(M, /&\f/g, b[k]))) && (c[g++] = C);
  return jr(e, r, t, o === 0 ? wt : s, c, l, p);
}
function La(e, r, t) {
  return jr(e, r, t, St, Fr(Ra()), fr(e, 2, -2), 0);
}
function Zt(e, r, t, n) {
  return jr(e, r, t, kt, fr(e, 0, n), fr(e, n + 1, -1), n);
}
function er(e, r) {
  for (var t = "", n = Tt(e), o = 0; o < n; o++)
    t += r(e[o], o, e, r) || "";
  return t;
}
function Ba(e, r, t, n) {
  switch (e.type) {
    case _a:
      if (e.children.length) break;
    case Ea:
    case kt:
      return e.return = e.return || e.value;
    case St:
      return "";
    case Ln:
      return e.return = e.value + "{" + er(e.children, n) + "}";
    case wt:
      e.value = e.props.join(",");
  }
  return Te(t = er(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function Wa(e) {
  var r = Tt(e);
  return function(t, n, o, i) {
    for (var a = "", s = 0; s < r; s++)
      a += e[s](t, n, o, i) || "";
    return a;
  };
}
function qa(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
var Va = function(r, t, n) {
  for (var o = 0, i = 0; o = i, i = _e(), o === 38 && i === 12 && (t[n] = 1), !gr(i); )
    fe();
  return yr(r, le);
}, Ua = function(r, t) {
  var n = -1, o = 44;
  do
    switch (gr(o)) {
      case 0:
        o === 38 && _e() === 12 && (t[n] = 1), r[n] += Va(le - 1, t, n);
        break;
      case 2:
        r[n] += Cr(o);
        break;
      case 4:
        if (o === 44) {
          r[++n] = _e() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += Fr(o);
    }
  while (o = fe());
  return r;
}, Ha = function(r, t) {
  return Vn(Ua(qn(r), t));
}, Qt = /* @__PURE__ */ new WeakMap(), Ya = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, o = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !Qt.get(n)) && !o) {
      Qt.set(r, !0);
      for (var i = [], a = Ha(t, i), s = n.props, c = 0, l = 0; c < a.length; c++)
        for (var p = 0; p < s.length; p++, l++)
          r.props[l] = i[c] ? a[c].replace(/&\f/g, s[p]) : s[p] + " " + a[c];
    }
  }
}, Ka = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, Ga = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Xa = function(r) {
  return r.type === "comm" && r.children.indexOf(Ga) > -1;
}, Ja = function(r) {
  return function(t, n, o) {
    if (!(t.type !== "rule" || r.compat)) {
      var i = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var a = !!t.parent, s = a ? t.parent.children : (
          // global rule at the root level
          o
        ), c = s.length - 1; c >= 0; c--) {
          var l = s[c];
          if (l.line < t.line)
            break;
          if (l.column < t.column) {
            if (Xa(l))
              return;
            break;
          }
        }
        i.forEach(function(p) {
          console.error('The pseudo class "' + p + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + p.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Un = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Za = function(r, t) {
  for (var n = r - 1; n >= 0; n--)
    if (!Un(t[n]))
      return !0;
  return !1;
}, en = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, Qa = function(r, t, n) {
  Un(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), en(r)) : Za(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), en(r)));
};
function Hn(e, r) {
  switch (Pa(e, r)) {
    case 5103:
      return N + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return N + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return N + e + Ar + e + ie + e + e;
    case 6828:
    case 4268:
      return N + e + ie + e + e;
    case 6165:
      return N + e + ie + "flex-" + e + e;
    case 5187:
      return N + e + L(e, /(\w+).+(:[^]+)/, N + "box-$1$2" + ie + "flex-$1$2") + e;
    case 5443:
      return N + e + ie + "flex-item-" + L(e, /flex-|-self/, "") + e;
    case 4675:
      return N + e + ie + "flex-line-pack" + L(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return N + e + ie + L(e, "shrink", "negative") + e;
    case 5292:
      return N + e + ie + L(e, "basis", "preferred-size") + e;
    case 6060:
      return N + "box-" + L(e, "-grow", "") + N + e + ie + L(e, "grow", "positive") + e;
    case 4554:
      return N + L(e, /([^-])(transform)/g, "$1" + N + "$2") + e;
    case 6187:
      return L(L(L(e, /(zoom-|grab)/, N + "$1"), /(image-set)/, N + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return L(e, /(image-set\([^]*)/, N + "$1$`$1");
    case 4968:
      return L(L(e, /(.+:)(flex-)?(.*)/, N + "box-pack:$3" + ie + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + N + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return L(e, /(.+)-inline(.+)/, N + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Te(e) - 1 - r > 6) switch (te(e, r + 1)) {
        case 109:
          if (te(e, r + 4) !== 45) break;
        case 102:
          return L(e, /(.+:)(.+)-([^]+)/, "$1" + N + "$2-$3$1" + Ar + (te(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~ct(e, "stretch") ? Hn(L(e, "stretch", "fill-available"), r) + e : e;
      }
      break;
    case 4949:
      if (te(e, r + 1) !== 115) break;
    case 6444:
      switch (te(e, Te(e) - 3 - (~ct(e, "!important") && 10))) {
        case 107:
          return L(e, ":", ":" + N) + e;
        case 101:
          return L(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + N + (te(e, 14) === 45 ? "inline-" : "") + "box$3$1" + N + "$2$3$1" + ie + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (te(e, r + 11)) {
        case 114:
          return N + e + ie + L(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return N + e + ie + L(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return N + e + ie + L(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return N + e + ie + e + e;
  }
  return e;
}
var es = function(r, t, n, o) {
  if (r.length > -1 && !r.return) switch (r.type) {
    case kt:
      r.return = Hn(r.value, r.length);
      break;
    case Ln:
      return er([cr(r, {
        value: L(r.value, "@", "@" + N)
      })], o);
    case wt:
      if (r.length) return Aa(r.props, function(i) {
        switch (Ma(i, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return er([cr(r, {
              props: [L(i, /:(read-\w+)/, ":" + Ar + "$1")]
            })], o);
          case "::placeholder":
            return er([cr(r, {
              props: [L(i, /:(plac\w+)/, ":" + N + "input-$1")]
            }), cr(r, {
              props: [L(i, /:(plac\w+)/, ":" + Ar + "$1")]
            }), cr(r, {
              props: [L(i, /:(plac\w+)/, ie + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, rs = [es], ts = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(f) {
      var g = f.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(f), f.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || rs;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i = {}, a, s = [];
  a = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(f) {
      for (var g = f.getAttribute("data-emotion").split(" "), k = 1; k < g.length; k++)
        i[g[k]] = !0;
      s.push(f);
    }
  );
  var c, l = [Ya, Ka];
  process.env.NODE_ENV !== "production" && l.push(Ja({
    get compat() {
      return x.compat;
    }
  }), Qa);
  {
    var p, h = [Ba, process.env.NODE_ENV !== "production" ? function(f) {
      f.root || (f.return ? p.insert(f.return) : f.value && f.type !== St && p.insert(f.value + "{}"));
    } : qa(function(f) {
      p.insert(f);
    })], b = Wa(l.concat(o, h)), S = function(g) {
      return er(Na(g), b);
    };
    c = function(g, k, M, C) {
      p = M, process.env.NODE_ENV !== "production" && k.map !== void 0 && (p = {
        insert: function(y) {
          M.insert(y + k.map);
        }
      }), S(g ? g + "{" + k.styles + "}" : k.styles), C && (x.inserted[k.name] = !0);
    };
  }
  var x = {
    key: t,
    sheet: new Ta({
      key: t,
      container: a,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return x.sheet.hydrate(s), x;
};
let ut;
typeof document == "object" && (ut = ts({
  key: "css",
  prepend: !0
}));
function Yn(e) {
  const {
    injectFirst: r,
    children: t
  } = e;
  return r && ut ? /* @__PURE__ */ u(bi, {
    value: ut,
    children: t
  }) : t;
}
process.env.NODE_ENV !== "production" && (Yn.propTypes = {
  /**
   * Your component tree.
   */
  children: de.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: de.bool
});
function ns(e) {
  return e == null || Object.keys(e).length === 0;
}
function Kn(e) {
  const {
    styles: r,
    defaultTheme: t = {}
  } = e;
  return /* @__PURE__ */ u(yi, {
    styles: typeof r == "function" ? (o) => r(ns(o) ? t : o) : r
  });
}
process.env.NODE_ENV !== "production" && (Kn.propTypes = {
  defaultTheme: de.object,
  styles: de.oneOfType([de.array, de.string, de.object, de.func])
});
/**
 * @mui/styled-engine v5.16.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function os(e, r) {
  const t = gi(e, r);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), t(...n);
  } : t;
}
const is = (e, r) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = r(e.__emotion_styles));
}, as = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: Kn,
  StyledEngineProvider: Yn,
  ThemeContext: hi,
  css: Rn,
  default: os,
  internal_processStyles: is,
  keyframes: mi
}, Symbol.toStringTag, { value: "Module" }));
function je(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const r = Object.getPrototypeOf(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Gn(e) {
  if (!je(e))
    return e;
  const r = {};
  return Object.keys(e).forEach((t) => {
    r[t] = Gn(e[t]);
  }), r;
}
function Ce(e, r, t = {
  clone: !0
}) {
  const n = t.clone ? X({}, e) : e;
  return je(e) && je(r) && Object.keys(r).forEach((o) => {
    je(r[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && je(e[o]) ? n[o] = Ce(e[o], r[o], t) : t.clone ? n[o] = je(r[o]) ? Gn(r[o]) : r[o] : n[o] = r[o];
  }), n;
}
const ss = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ce,
  isPlainObject: je
}, Symbol.toStringTag, { value: "Module" })), cs = ["values", "unit", "step"], ls = (e) => {
  const r = Object.keys(e).map((t) => ({
    key: t,
    val: e[t]
  })) || [];
  return r.sort((t, n) => t.val - n.val), r.reduce((t, n) => X({}, t, {
    [n.key]: n.val
  }), {});
};
function Xn(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: r = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: t = "px",
    step: n = 5
  } = e, o = Ue(e, cs), i = ls(r), a = Object.keys(i);
  function s(b) {
    return `@media (min-width:${typeof r[b] == "number" ? r[b] : b}${t})`;
  }
  function c(b) {
    return `@media (max-width:${(typeof r[b] == "number" ? r[b] : b) - n / 100}${t})`;
  }
  function l(b, S) {
    const x = a.indexOf(S);
    return `@media (min-width:${typeof r[b] == "number" ? r[b] : b}${t}) and (max-width:${(x !== -1 && typeof r[a[x]] == "number" ? r[a[x]] : S) - n / 100}${t})`;
  }
  function p(b) {
    return a.indexOf(b) + 1 < a.length ? l(b, a[a.indexOf(b) + 1]) : s(b);
  }
  function h(b) {
    const S = a.indexOf(b);
    return S === 0 ? s(a[1]) : S === a.length - 1 ? c(a[S]) : l(b, a[a.indexOf(b) + 1]).replace("@media", "@media not all and");
  }
  return X({
    keys: a,
    values: i,
    up: s,
    down: c,
    between: l,
    only: p,
    not: h,
    unit: t
  }, o);
}
const us = {
  borderRadius: 4
}, ds = us, ps = process.env.NODE_ENV !== "production" ? de.oneOfType([de.number, de.string, de.object, de.array]) : {}, Le = ps;
function ur(e, r) {
  return r ? Ce(e, r, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Et = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, rn = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Et[e]}px)`
};
function ze(e, r, t) {
  const n = e.theme || {};
  if (Array.isArray(r)) {
    const i = n.breakpoints || rn;
    return r.reduce((a, s, c) => (a[i.up(i.keys[c])] = t(r[c]), a), {});
  }
  if (typeof r == "object") {
    const i = n.breakpoints || rn;
    return Object.keys(r).reduce((a, s) => {
      if (Object.keys(i.values || Et).indexOf(s) !== -1) {
        const c = i.up(s);
        a[c] = t(r[s], s);
      } else {
        const c = s;
        a[c] = r[c];
      }
      return a;
    }, {});
  }
  return t(r);
}
function fs(e = {}) {
  var r;
  return ((r = e.keys) == null ? void 0 : r.reduce((n, o) => {
    const i = e.up(o);
    return n[i] = {}, n;
  }, {})) || {};
}
function gs(e, r) {
  return e.reduce((t, n) => {
    const o = t[n];
    return (!o || Object.keys(o).length === 0) && delete t[n], t;
  }, r);
}
function _t(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : pr(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const bs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _t
}, Symbol.toStringTag, { value: "Module" }));
function Nr(e, r, t = !0) {
  if (!r || typeof r != "string")
    return null;
  if (e && e.vars && t) {
    const n = `vars.${r}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (n != null)
      return n;
  }
  return r.split(".").reduce((n, o) => n && n[o] != null ? n[o] : null, e);
}
function Rr(e, r, t, n = t) {
  let o;
  return typeof e == "function" ? o = e(t) : Array.isArray(e) ? o = e[t] || n : o = Nr(e, t) || n, r && (o = r(o, n, e)), o;
}
function Z(e) {
  const {
    prop: r,
    cssProperty: t = e.prop,
    themeKey: n,
    transform: o
  } = e, i = (a) => {
    if (a[r] == null)
      return null;
    const s = a[r], c = a.theme, l = Nr(c, n) || {};
    return ze(a, s, (h) => {
      let b = Rr(l, o, h);
      return h === b && typeof h == "string" && (b = Rr(l, o, `${r}${h === "default" ? "" : _t(h)}`, h)), t === !1 ? b : {
        [t]: b
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [r]: Le
  } : {}, i.filterProps = [r], i;
}
function ys(e) {
  const r = {};
  return (t) => (r[t] === void 0 && (r[t] = e(t)), r[t]);
}
const hs = {
  m: "margin",
  p: "padding"
}, ms = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, tn = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, xs = ys((e) => {
  if (e.length > 2)
    if (tn[e])
      e = tn[e];
    else
      return [e];
  const [r, t] = e.split(""), n = hs[r], o = ms[t] || "";
  return Array.isArray(o) ? o.map((i) => n + i) : [n + o];
}), Lr = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Br = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], $s = [...Lr, ...Br];
function hr(e, r, t, n) {
  var o;
  const i = (o = Nr(e, r, !1)) != null ? o : t;
  return typeof i == "number" ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && typeof a != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${a}.`), i * a) : Array.isArray(i) ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > i.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${a} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${r}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${r}\` as a number.`].join(`
`))), i[a]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${r}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Jn(e) {
  return hr(e, "spacing", 8, "spacing");
}
function mr(e, r) {
  if (typeof r == "string" || r == null)
    return r;
  const t = Math.abs(r), n = e(t);
  return r >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function vs(e, r) {
  return (t) => e.reduce((n, o) => (n[o] = mr(r, t), n), {});
}
function Ss(e, r, t, n) {
  if (r.indexOf(t) === -1)
    return null;
  const o = xs(t), i = vs(o, n), a = e[t];
  return ze(e, a, i);
}
function Zn(e, r) {
  const t = Jn(e.theme);
  return Object.keys(e).map((n) => Ss(e, r, n, t)).reduce(ur, {});
}
function K(e) {
  return Zn(e, Lr);
}
K.propTypes = process.env.NODE_ENV !== "production" ? Lr.reduce((e, r) => (e[r] = Le, e), {}) : {};
K.filterProps = Lr;
function G(e) {
  return Zn(e, Br);
}
G.propTypes = process.env.NODE_ENV !== "production" ? Br.reduce((e, r) => (e[r] = Le, e), {}) : {};
G.filterProps = Br;
process.env.NODE_ENV !== "production" && $s.reduce((e, r) => (e[r] = Le, e), {});
function ws(e = 8) {
  if (e.mui)
    return e;
  const r = Jn({
    spacing: e
  }), t = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((i) => {
    const a = r(i);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return t.mui = !0, t;
}
function Wr(...e) {
  const r = e.reduce((n, o) => (o.filterProps.forEach((i) => {
    n[i] = o;
  }), n), {}), t = (n) => Object.keys(n).reduce((o, i) => r[i] ? ur(o, r[i](n)) : o, {});
  return t.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, o) => Object.assign(n, o.propTypes), {}) : {}, t.filterProps = e.reduce((n, o) => n.concat(o.filterProps), []), t;
}
function xe(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Se(e, r) {
  return Z({
    prop: e,
    themeKey: "borders",
    transform: r
  });
}
const ks = Se("border", xe), Ts = Se("borderTop", xe), Es = Se("borderRight", xe), _s = Se("borderBottom", xe), Cs = Se("borderLeft", xe), Os = Se("borderColor"), Ps = Se("borderTopColor"), Ms = Se("borderRightColor"), As = Se("borderBottomColor"), Rs = Se("borderLeftColor"), Is = Se("outline", xe), zs = Se("outlineColor"), qr = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const r = hr(e.theme, "shape.borderRadius", 4, "borderRadius"), t = (n) => ({
      borderRadius: mr(r, n)
    });
    return ze(e, e.borderRadius, t);
  }
  return null;
};
qr.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Le
} : {};
qr.filterProps = ["borderRadius"];
Wr(ks, Ts, Es, _s, Cs, Os, Ps, Ms, As, Rs, qr, Is, zs);
const Vr = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const r = hr(e.theme, "spacing", 8, "gap"), t = (n) => ({
      gap: mr(r, n)
    });
    return ze(e, e.gap, t);
  }
  return null;
};
Vr.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Le
} : {};
Vr.filterProps = ["gap"];
const Ur = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const r = hr(e.theme, "spacing", 8, "columnGap"), t = (n) => ({
      columnGap: mr(r, n)
    });
    return ze(e, e.columnGap, t);
  }
  return null;
};
Ur.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Le
} : {};
Ur.filterProps = ["columnGap"];
const Hr = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const r = hr(e.theme, "spacing", 8, "rowGap"), t = (n) => ({
      rowGap: mr(r, n)
    });
    return ze(e, e.rowGap, t);
  }
  return null;
};
Hr.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Le
} : {};
Hr.filterProps = ["rowGap"];
const Fs = Z({
  prop: "gridColumn"
}), Ds = Z({
  prop: "gridRow"
}), js = Z({
  prop: "gridAutoFlow"
}), Ns = Z({
  prop: "gridAutoColumns"
}), Ls = Z({
  prop: "gridAutoRows"
}), Bs = Z({
  prop: "gridTemplateColumns"
}), Ws = Z({
  prop: "gridTemplateRows"
}), qs = Z({
  prop: "gridTemplateAreas"
}), Vs = Z({
  prop: "gridArea"
});
Wr(Vr, Ur, Hr, Fs, Ds, js, Ns, Ls, Bs, Ws, qs, Vs);
function rr(e, r) {
  return r === "grey" ? r : e;
}
const Us = Z({
  prop: "color",
  themeKey: "palette",
  transform: rr
}), Hs = Z({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: rr
}), Ys = Z({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: rr
});
Wr(Us, Hs, Ys);
function pe(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Ks = Z({
  prop: "width",
  transform: pe
}), Ct = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const r = (t) => {
      var n, o;
      const i = ((n = e.theme) == null || (n = n.breakpoints) == null || (n = n.values) == null ? void 0 : n[t]) || Et[t];
      return i ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${i}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: i
      } : {
        maxWidth: pe(t)
      };
    };
    return ze(e, e.maxWidth, r);
  }
  return null;
};
Ct.filterProps = ["maxWidth"];
const Gs = Z({
  prop: "minWidth",
  transform: pe
}), Xs = Z({
  prop: "height",
  transform: pe
}), Js = Z({
  prop: "maxHeight",
  transform: pe
}), Zs = Z({
  prop: "minHeight",
  transform: pe
});
Z({
  prop: "size",
  cssProperty: "width",
  transform: pe
});
Z({
  prop: "size",
  cssProperty: "height",
  transform: pe
});
const Qs = Z({
  prop: "boxSizing"
});
Wr(Ks, Ct, Gs, Xs, Js, Zs, Qs);
const ec = {
  // borders
  border: {
    themeKey: "borders",
    transform: xe
  },
  borderTop: {
    themeKey: "borders",
    transform: xe
  },
  borderRight: {
    themeKey: "borders",
    transform: xe
  },
  borderBottom: {
    themeKey: "borders",
    transform: xe
  },
  borderLeft: {
    themeKey: "borders",
    transform: xe
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: xe
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: qr
  },
  // palette
  color: {
    themeKey: "palette",
    transform: rr
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: rr
  },
  backgroundColor: {
    themeKey: "palette",
    transform: rr
  },
  // spacing
  p: {
    style: G
  },
  pt: {
    style: G
  },
  pr: {
    style: G
  },
  pb: {
    style: G
  },
  pl: {
    style: G
  },
  px: {
    style: G
  },
  py: {
    style: G
  },
  padding: {
    style: G
  },
  paddingTop: {
    style: G
  },
  paddingRight: {
    style: G
  },
  paddingBottom: {
    style: G
  },
  paddingLeft: {
    style: G
  },
  paddingX: {
    style: G
  },
  paddingY: {
    style: G
  },
  paddingInline: {
    style: G
  },
  paddingInlineStart: {
    style: G
  },
  paddingInlineEnd: {
    style: G
  },
  paddingBlock: {
    style: G
  },
  paddingBlockStart: {
    style: G
  },
  paddingBlockEnd: {
    style: G
  },
  m: {
    style: K
  },
  mt: {
    style: K
  },
  mr: {
    style: K
  },
  mb: {
    style: K
  },
  ml: {
    style: K
  },
  mx: {
    style: K
  },
  my: {
    style: K
  },
  margin: {
    style: K
  },
  marginTop: {
    style: K
  },
  marginRight: {
    style: K
  },
  marginBottom: {
    style: K
  },
  marginLeft: {
    style: K
  },
  marginX: {
    style: K
  },
  marginY: {
    style: K
  },
  marginInline: {
    style: K
  },
  marginInlineStart: {
    style: K
  },
  marginInlineEnd: {
    style: K
  },
  marginBlock: {
    style: K
  },
  marginBlockStart: {
    style: K
  },
  marginBlockEnd: {
    style: K
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Vr
  },
  rowGap: {
    style: Hr
  },
  columnGap: {
    style: Ur
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: pe
  },
  maxWidth: {
    style: Ct
  },
  minWidth: {
    transform: pe
  },
  height: {
    transform: pe
  },
  maxHeight: {
    transform: pe
  },
  minHeight: {
    transform: pe
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, xr = ec;
function rc(...e) {
  const r = e.reduce((n, o) => n.concat(Object.keys(o)), []), t = new Set(r);
  return e.every((n) => t.size === Object.keys(n).length);
}
function tc(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function Qn() {
  function e(t, n, o, i) {
    const a = {
      [t]: n,
      theme: o
    }, s = i[t];
    if (!s)
      return {
        [t]: n
      };
    const {
      cssProperty: c = t,
      themeKey: l,
      transform: p,
      style: h
    } = s;
    if (n == null)
      return null;
    if (l === "typography" && n === "inherit")
      return {
        [t]: n
      };
    const b = Nr(o, l) || {};
    return h ? h(a) : ze(a, n, (x) => {
      let f = Rr(b, p, x);
      return x === f && typeof x == "string" && (f = Rr(b, p, `${t}${x === "default" ? "" : _t(x)}`, x)), c === !1 ? f : {
        [c]: f
      };
    });
  }
  function r(t) {
    var n;
    const {
      sx: o,
      theme: i = {}
    } = t || {};
    if (!o)
      return null;
    const a = (n = i.unstable_sxConfig) != null ? n : xr;
    function s(c) {
      let l = c;
      if (typeof c == "function")
        l = c(i);
      else if (typeof c != "object")
        return c;
      if (!l)
        return null;
      const p = fs(i.breakpoints), h = Object.keys(p);
      let b = p;
      return Object.keys(l).forEach((S) => {
        const x = tc(l[S], i);
        if (x != null)
          if (typeof x == "object")
            if (a[S])
              b = ur(b, e(S, x, i, a));
            else {
              const f = ze({
                theme: i
              }, x, (g) => ({
                [S]: g
              }));
              rc(f, x) ? b[S] = r({
                sx: x,
                theme: i
              }) : b = ur(b, f);
            }
          else
            b = ur(b, e(S, x, i, a));
      }), gs(h, b);
    }
    return Array.isArray(o) ? o.map(s) : s(o);
  }
  return r;
}
const Yr = Qn();
Yr.filterProps = ["sx"];
function eo(e, r) {
  const t = this;
  return t.vars && typeof t.getColorSchemeSelector == "function" ? {
    [t.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: r
  } : t.palette.mode === e ? r : {};
}
const nc = ["breakpoints", "palette", "spacing", "shape"];
function ro(e = {}, ...r) {
  const {
    breakpoints: t = {},
    palette: n = {},
    spacing: o,
    shape: i = {}
  } = e, a = Ue(e, nc), s = Xn(t), c = ws(o);
  let l = Ce({
    breakpoints: s,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: X({
      mode: "light"
    }, n),
    spacing: c,
    shape: X({}, ds, i)
  }, a);
  return l.applyStyles = eo, l = r.reduce((p, h) => Ce(p, h), l), l.unstable_sxConfig = X({}, xr, a == null ? void 0 : a.unstable_sxConfig), l.unstable_sx = function(h) {
    return Yr({
      sx: h,
      theme: this
    });
  }, l;
}
const oc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ro,
  private_createBreakpoints: Xn,
  unstable_applyStyles: eo
}, Symbol.toStringTag, { value: "Module" })), ic = ["sx"], ac = (e) => {
  var r, t;
  const n = {
    systemProps: {},
    otherProps: {}
  }, o = (r = e == null || (t = e.theme) == null ? void 0 : t.unstable_sxConfig) != null ? r : xr;
  return Object.keys(e).forEach((i) => {
    o[i] ? n.systemProps[i] = e[i] : n.otherProps[i] = e[i];
  }), n;
};
function sc(e) {
  const {
    sx: r
  } = e, t = Ue(e, ic), {
    systemProps: n,
    otherProps: o
  } = ac(t);
  let i;
  return Array.isArray(r) ? i = [n, ...r] : typeof r == "function" ? i = (...a) => {
    const s = r(...a);
    return je(s) ? X({}, n, s) : n;
  } : i = X({}, n, r), X({}, o, {
    sx: i
  });
}
const cc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yr,
  extendSxProp: sc,
  unstable_createStyleFunctionSx: Qn,
  unstable_defaultSxConfig: xr
}, Symbol.toStringTag, { value: "Module" })), nn = (e) => e, lc = () => {
  let e = nn;
  return {
    configure(r) {
      e = r;
    },
    generate(r) {
      return e(r);
    },
    reset() {
      e = nn;
    }
  };
}, uc = lc(), dc = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function pc(e, r, t = "Mui") {
  const n = dc[r];
  return n ? `${t}-${n}` : `${uc.generate(e)}-${r}`;
}
var dt = { exports: {} }, V = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var on;
function fc() {
  if (on) return V;
  on = 1;
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), x;
  x = Symbol.for("react.module.reference");
  function f(g) {
    if (typeof g == "object" && g !== null) {
      var k = g.$$typeof;
      switch (k) {
        case e:
          switch (g = g.type, g) {
            case t:
            case o:
            case n:
            case l:
            case p:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case s:
                case a:
                case c:
                case b:
                case h:
                case i:
                  return g;
                default:
                  return k;
              }
          }
        case r:
          return k;
      }
    }
  }
  return V.ContextConsumer = a, V.ContextProvider = i, V.Element = e, V.ForwardRef = c, V.Fragment = t, V.Lazy = b, V.Memo = h, V.Portal = r, V.Profiler = o, V.StrictMode = n, V.Suspense = l, V.SuspenseList = p, V.isAsyncMode = function() {
    return !1;
  }, V.isConcurrentMode = function() {
    return !1;
  }, V.isContextConsumer = function(g) {
    return f(g) === a;
  }, V.isContextProvider = function(g) {
    return f(g) === i;
  }, V.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, V.isForwardRef = function(g) {
    return f(g) === c;
  }, V.isFragment = function(g) {
    return f(g) === t;
  }, V.isLazy = function(g) {
    return f(g) === b;
  }, V.isMemo = function(g) {
    return f(g) === h;
  }, V.isPortal = function(g) {
    return f(g) === r;
  }, V.isProfiler = function(g) {
    return f(g) === o;
  }, V.isStrictMode = function(g) {
    return f(g) === n;
  }, V.isSuspense = function(g) {
    return f(g) === l;
  }, V.isSuspenseList = function(g) {
    return f(g) === p;
  }, V.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === t || g === o || g === n || g === l || g === p || g === S || typeof g == "object" && g !== null && (g.$$typeof === b || g.$$typeof === h || g.$$typeof === i || g.$$typeof === a || g.$$typeof === c || g.$$typeof === x || g.getModuleId !== void 0);
  }, V.typeOf = f, V;
}
var U = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var an;
function gc() {
  return an || (an = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), x = !1, f = !1, g = !1, k = !1, M = !1, C;
    C = Symbol.for("react.module.reference");
    function D(T) {
      return !!(typeof T == "string" || typeof T == "function" || T === t || T === o || M || T === n || T === l || T === p || k || T === S || x || f || g || typeof T == "object" && T !== null && (T.$$typeof === b || T.$$typeof === h || T.$$typeof === i || T.$$typeof === a || T.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      T.$$typeof === C || T.getModuleId !== void 0));
    }
    function y(T) {
      if (typeof T == "object" && T !== null) {
        var Ye = T.$$typeof;
        switch (Ye) {
          case e:
            var vr = T.type;
            switch (vr) {
              case t:
              case o:
              case n:
              case l:
              case p:
                return vr;
              default:
                var Rt = vr && vr.$$typeof;
                switch (Rt) {
                  case s:
                  case a:
                  case c:
                  case b:
                  case h:
                  case i:
                    return Rt;
                  default:
                    return Ye;
                }
            }
          case r:
            return Ye;
        }
      }
    }
    var B = a, R = i, we = e, Fe = c, Oe = t, J = b, ne = h, ke = r, ue = o, Be = n, se = l, Pe = p, We = !1, He = !1;
    function m(T) {
      return We || (We = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function w(T) {
      return He || (He = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function A(T) {
      return y(T) === a;
    }
    function O(T) {
      return y(T) === i;
    }
    function E(T) {
      return typeof T == "object" && T !== null && T.$$typeof === e;
    }
    function I(T) {
      return y(T) === c;
    }
    function _(T) {
      return y(T) === t;
    }
    function P(T) {
      return y(T) === b;
    }
    function z(T) {
      return y(T) === h;
    }
    function j(T) {
      return y(T) === r;
    }
    function F(T) {
      return y(T) === o;
    }
    function oe(T) {
      return y(T) === n;
    }
    function v(T) {
      return y(T) === l;
    }
    function he(T) {
      return y(T) === p;
    }
    U.ContextConsumer = B, U.ContextProvider = R, U.Element = we, U.ForwardRef = Fe, U.Fragment = Oe, U.Lazy = J, U.Memo = ne, U.Portal = ke, U.Profiler = ue, U.StrictMode = Be, U.Suspense = se, U.SuspenseList = Pe, U.isAsyncMode = m, U.isConcurrentMode = w, U.isContextConsumer = A, U.isContextProvider = O, U.isElement = E, U.isForwardRef = I, U.isFragment = _, U.isLazy = P, U.isMemo = z, U.isPortal = j, U.isProfiler = F, U.isStrictMode = oe, U.isSuspense = v, U.isSuspenseList = he, U.isValidElementType = D, U.typeOf = y;
  }()), U;
}
process.env.NODE_ENV === "production" ? dt.exports = fc() : dt.exports = gc();
var sn = dt.exports;
const bc = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function to(e) {
  const r = `${e}`.match(bc);
  return r && r[1] || "";
}
function no(e, r = "") {
  return e.displayName || e.name || to(e) || r;
}
function cn(e, r, t) {
  const n = no(r);
  return e.displayName || (n !== "" ? `${t}(${n})` : t);
}
function yc(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return no(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case sn.ForwardRef:
          return cn(e, e.render, "ForwardRef");
        case sn.Memo:
          return cn(e, e.type, "memo");
        default:
          return;
      }
  }
}
const hc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yc,
  getFunctionName: to
}, Symbol.toStringTag, { value: "Module" }));
function mc(e, r = Number.MIN_SAFE_INTEGER, t = Number.MAX_SAFE_INTEGER) {
  return Math.max(r, Math.min(e, t));
}
const xc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mc
}, Symbol.toStringTag, { value: "Module" }));
function $c(e, r) {
  return X({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, r);
}
var Q = {}, oo = { exports: {} };
(function(e) {
  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(oo);
var io = oo.exports;
const vc = /* @__PURE__ */ Ne(da), Sc = /* @__PURE__ */ Ne(xc);
var ao = io;
Object.defineProperty(Q, "__esModule", {
  value: !0
});
Q.alpha = uo;
Q.blend = Ic;
Q.colorChannel = void 0;
var wc = Q.darken = Pt;
Q.decomposeColor = $e;
Q.emphasize = po;
var ln = Q.getContrastRatio = Oc;
Q.getLuminance = Ir;
Q.hexToRgb = so;
Q.hslToRgb = lo;
var kc = Q.lighten = Mt;
Q.private_safeAlpha = Pc;
Q.private_safeColorChannel = void 0;
Q.private_safeDarken = Mc;
Q.private_safeEmphasize = Rc;
Q.private_safeLighten = Ac;
Q.recomposeColor = ir;
Q.rgbToHex = Cc;
var un = ao(vc), Tc = ao(Sc);
function Ot(e, r = 0, t = 1) {
  return process.env.NODE_ENV !== "production" && (e < r || e > t) && console.error(`MUI: The value provided ${e} is out of range [${r}, ${t}].`), (0, Tc.default)(e, r, t);
}
function so(e) {
  e = e.slice(1);
  const r = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let t = e.match(r);
  return t && t[0].length === 1 && (t = t.map((n) => n + n)), t ? `rgb${t.length === 4 ? "a" : ""}(${t.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Ec(e) {
  const r = e.toString(16);
  return r.length === 1 ? `0${r}` : r;
}
function $e(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return $e(so(e));
  const r = e.indexOf("("), t = e.substring(0, r);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(t) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, un.default)(9, e));
  let n = e.substring(r + 1, e.length - 1), o;
  if (t === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, un.default)(10, o));
  } else
    n = n.split(",");
  return n = n.map((i) => parseFloat(i)), {
    type: t,
    values: n,
    colorSpace: o
  };
}
const co = (e) => {
  const r = $e(e);
  return r.values.slice(0, 3).map((t, n) => r.type.indexOf("hsl") !== -1 && n !== 0 ? `${t}%` : t).join(" ");
};
Q.colorChannel = co;
const _c = (e, r) => {
  try {
    return co(e);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
};
Q.private_safeColorChannel = _c;
function ir(e) {
  const {
    type: r,
    colorSpace: t
  } = e;
  let {
    values: n
  } = e;
  return r.indexOf("rgb") !== -1 ? n = n.map((o, i) => i < 3 ? parseInt(o, 10) : o) : r.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), r.indexOf("color") !== -1 ? n = `${t} ${n.join(" ")}` : n = `${n.join(", ")}`, `${r}(${n})`;
}
function Cc(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: r
  } = $e(e);
  return `#${r.map((t, n) => Ec(n === 3 ? Math.round(255 * t) : t)).join("")}`;
}
function lo(e) {
  e = $e(e);
  const {
    values: r
  } = e, t = r[0], n = r[1] / 100, o = r[2] / 100, i = n * Math.min(o, 1 - o), a = (l, p = (l + t / 30) % 12) => o - i * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let s = "rgb";
  const c = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (s += "a", c.push(r[3])), ir({
    type: s,
    values: c
  });
}
function Ir(e) {
  e = $e(e);
  let r = e.type === "hsl" || e.type === "hsla" ? $e(lo(e)).values : e.values;
  return r = r.map((t) => (e.type !== "color" && (t /= 255), t <= 0.03928 ? t / 12.92 : ((t + 0.055) / 1.055) ** 2.4)), Number((0.2126 * r[0] + 0.7152 * r[1] + 0.0722 * r[2]).toFixed(3));
}
function Oc(e, r) {
  const t = Ir(e), n = Ir(r);
  return (Math.max(t, n) + 0.05) / (Math.min(t, n) + 0.05);
}
function uo(e, r) {
  return e = $e(e), r = Ot(r), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${r}` : e.values[3] = r, ir(e);
}
function Pc(e, r, t) {
  try {
    return uo(e, r);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function Pt(e, r) {
  if (e = $e(e), r = Ot(r), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - r;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] *= 1 - r;
  return ir(e);
}
function Mc(e, r, t) {
  try {
    return Pt(e, r);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function Mt(e, r) {
  if (e = $e(e), r = Ot(r), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * r;
  else if (e.type.indexOf("rgb") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (255 - e.values[t]) * r;
  else if (e.type.indexOf("color") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (1 - e.values[t]) * r;
  return ir(e);
}
function Ac(e, r, t) {
  try {
    return Mt(e, r);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function po(e, r = 0.15) {
  return Ir(e) > 0.5 ? Pt(e, r) : Mt(e, r);
}
function Rc(e, r, t) {
  try {
    return po(e, r);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function Ic(e, r, t, n = 1) {
  const o = (c, l) => Math.round((c ** (1 / n) * (1 - t) + l ** (1 / n) * t) ** n), i = $e(e), a = $e(r), s = [o(i.values[0], a.values[0]), o(i.values[1], a.values[1]), o(i.values[2], a.values[2])];
  return ir({
    type: "rgb",
    values: s
  });
}
const zc = {
  black: "#000",
  white: "#fff"
}, br = zc, Fc = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Dc = Fc, jc = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Ke = jc, Nc = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Ge = Nc, Lc = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, lr = Lc, Bc = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Xe = Bc, Wc = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Je = Wc, qc = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, Ze = qc, Vc = ["mode", "contrastThreshold", "tonalOffset"], dn = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: br.white,
    default: br.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, rt = {
  text: {
    primary: br.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: br.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function pn(e, r, t, n) {
  const o = n.light || n, i = n.dark || n * 1.5;
  e[r] || (e.hasOwnProperty(t) ? e[r] = e[t] : r === "light" ? e.light = kc(e.main, o) : r === "dark" && (e.dark = wc(e.main, i)));
}
function Uc(e = "light") {
  return e === "dark" ? {
    main: Xe[200],
    light: Xe[50],
    dark: Xe[400]
  } : {
    main: Xe[700],
    light: Xe[400],
    dark: Xe[800]
  };
}
function Hc(e = "light") {
  return e === "dark" ? {
    main: Ke[200],
    light: Ke[50],
    dark: Ke[400]
  } : {
    main: Ke[500],
    light: Ke[300],
    dark: Ke[700]
  };
}
function Yc(e = "light") {
  return e === "dark" ? {
    main: Ge[500],
    light: Ge[300],
    dark: Ge[700]
  } : {
    main: Ge[700],
    light: Ge[400],
    dark: Ge[800]
  };
}
function Kc(e = "light") {
  return e === "dark" ? {
    main: Je[400],
    light: Je[300],
    dark: Je[700]
  } : {
    main: Je[700],
    light: Je[500],
    dark: Je[900]
  };
}
function Gc(e = "light") {
  return e === "dark" ? {
    main: Ze[400],
    light: Ze[300],
    dark: Ze[700]
  } : {
    main: Ze[800],
    light: Ze[500],
    dark: Ze[900]
  };
}
function Xc(e = "light") {
  return e === "dark" ? {
    main: lr[400],
    light: lr[300],
    dark: lr[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: lr[500],
    dark: lr[900]
  };
}
function Jc(e) {
  const {
    mode: r = "light",
    contrastThreshold: t = 3,
    tonalOffset: n = 0.2
  } = e, o = Ue(e, Vc), i = e.primary || Uc(r), a = e.secondary || Hc(r), s = e.error || Yc(r), c = e.info || Kc(r), l = e.success || Gc(r), p = e.warning || Xc(r);
  function h(f) {
    const g = ln(f, rt.text.primary) >= t ? rt.text.primary : dn.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const k = ln(f, g);
      k < 3 && console.error([`MUI: The contrast ratio of ${k}:1 for ${g} on ${f}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return g;
  }
  const b = ({
    color: f,
    name: g,
    mainShade: k = 500,
    lightShade: M = 300,
    darkShade: C = 700
  }) => {
    if (f = X({}, f), !f.main && f[k] && (f.main = f[k]), !f.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${k}\` property.` : pr(11, g ? ` (${g})` : "", k));
    if (typeof f.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(f.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : pr(12, g ? ` (${g})` : "", JSON.stringify(f.main)));
    return pn(f, "light", M, n), pn(f, "dark", C, n), f.contrastText || (f.contrastText = h(f.main)), f;
  }, S = {
    dark: rt,
    light: dn
  };
  return process.env.NODE_ENV !== "production" && (S[r] || console.error(`MUI: The palette mode \`${r}\` is not supported.`)), Ce(X({
    // A collection of common colors.
    common: X({}, br),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: r,
    // The colors used to represent primary interface elements for a user.
    primary: b({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: b({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: b({
      color: s,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: b({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: b({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: b({
      color: l,
      name: "success"
    }),
    // The grey colors.
    grey: Dc,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: t,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: h,
    // Generate a rich color object.
    augmentColor: b,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, S[r]), o);
}
const Zc = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function Qc(e) {
  return Math.round(e * 1e5) / 1e5;
}
const fn = {
  textTransform: "uppercase"
}, gn = '"Roboto", "Helvetica", "Arial", sans-serif';
function el(e, r) {
  const t = typeof r == "function" ? r(e) : r, {
    fontFamily: n = gn,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: l = 16,
    // Apply the CSS properties to all the variants.
    allVariants: p,
    pxToRem: h
  } = t, b = Ue(t, Zc);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof l != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const S = o / 14, x = h || ((k) => `${k / l * S}rem`), f = (k, M, C, D, y) => X({
    fontFamily: n,
    fontWeight: k,
    fontSize: x(M),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: C
  }, n === gn ? {
    letterSpacing: `${Qc(D / M)}em`
  } : {}, y, p), g = {
    h1: f(i, 96, 1.167, -1.5),
    h2: f(i, 60, 1.2, -0.5),
    h3: f(a, 48, 1.167, 0),
    h4: f(a, 34, 1.235, 0.25),
    h5: f(a, 24, 1.334, 0),
    h6: f(s, 20, 1.6, 0.15),
    subtitle1: f(a, 16, 1.75, 0.15),
    subtitle2: f(s, 14, 1.57, 0.1),
    body1: f(a, 16, 1.5, 0.15),
    body2: f(a, 14, 1.43, 0.15),
    button: f(s, 14, 1.75, 0.4, fn),
    caption: f(a, 12, 1.66, 0.4),
    overline: f(a, 12, 2.66, 1, fn),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Ce(X({
    htmlFontSize: l,
    pxToRem: x,
    fontFamily: n,
    fontSize: o,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: s,
    fontWeightBold: c
  }, g), b, {
    clone: !1
    // No need to clone deep
  });
}
const rl = 0.2, tl = 0.14, nl = 0.12;
function H(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${rl})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${tl})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${nl})`].join(",");
}
const ol = ["none", H(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), H(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), H(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), H(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), H(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), H(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), H(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), H(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), H(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), H(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), H(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), H(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), H(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), H(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), H(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), H(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), H(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), H(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), H(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), H(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), H(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), H(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), H(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), H(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], il = ["duration", "easing", "delay"], al = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, sl = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function bn(e) {
  return `${Math.round(e)}ms`;
}
function cl(e) {
  if (!e)
    return 0;
  const r = e / 36;
  return Math.round((4 + 15 * r ** 0.25 + r / 5) * 10);
}
function ll(e) {
  const r = X({}, al, e.easing), t = X({}, sl, e.duration);
  return X({
    getAutoHeightDuration: cl,
    create: (o = ["all"], i = {}) => {
      const {
        duration: a = t.standard,
        easing: s = r.easeInOut,
        delay: c = 0
      } = i, l = Ue(i, il);
      if (process.env.NODE_ENV !== "production") {
        const p = (b) => typeof b == "string", h = (b) => !isNaN(parseFloat(b));
        !p(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !h(a) && !p(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), p(s) || console.error('MUI: Argument "easing" must be a string.'), !h(c) && !p(c) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(l).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(l).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((p) => `${p} ${typeof a == "string" ? a : bn(a)} ${s} ${typeof c == "string" ? c : bn(c)}`).join(",");
    }
  }, e, {
    easing: r,
    duration: t
  });
}
const ul = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, dl = ul, pl = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function fl(e = {}, ...r) {
  const {
    mixins: t = {},
    palette: n = {},
    transitions: o = {},
    typography: i = {}
  } = e, a = Ue(e, pl);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : pr(18));
  const s = Jc(n), c = ro(e);
  let l = Ce(c, {
    mixins: $c(c.breakpoints, t),
    palette: s,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: ol.slice(),
    typography: el(s, i),
    transitions: ll(o),
    zIndex: X({}, dl)
  });
  if (l = Ce(l, a), l = r.reduce((p, h) => Ce(p, h), l), process.env.NODE_ENV !== "production") {
    const p = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], h = (b, S) => {
      let x;
      for (x in b) {
        const f = b[x];
        if (p.indexOf(x) !== -1 && Object.keys(f).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const g = pc("", x);
            console.error([`MUI: The \`${S}\` component increases the CSS specificity of the \`${x}\` internal state.`, "You can not override it like this: ", JSON.stringify(b, null, 2), "", `Instead, you need to use the '&.${g}' syntax:`, JSON.stringify({
              root: {
                [`&.${g}`]: f
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          b[x] = {};
        }
      }
    };
    Object.keys(l.components).forEach((b) => {
      const S = l.components[b].styleOverrides;
      S && b.indexOf("Mui") === 0 && h(S, b);
    });
  }
  return l.unstable_sxConfig = X({}, xr, a == null ? void 0 : a.unstable_sxConfig), l.unstable_sx = function(h) {
    return Yr({
      sx: h,
      theme: this
    });
  }, l;
}
const gl = fl(), bl = gl;
var $r = {}, tt = { exports: {} }, yn;
function yl() {
  return yn || (yn = 1, function(e) {
    function r() {
      return e.exports = r = Object.assign ? Object.assign.bind() : function(t) {
        for (var n = 1; n < arguments.length; n++) {
          var o = arguments[n];
          for (var i in o)
            Object.prototype.hasOwnProperty.call(o, i) && (t[i] = o[i]);
        }
        return t;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r.apply(this, arguments);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(tt)), tt.exports;
}
var nt = { exports: {} }, hn;
function hl() {
  return hn || (hn = 1, function(e) {
    function r(t, n) {
      if (t == null) return {};
      var o = {}, i = Object.keys(t), a, s;
      for (s = 0; s < i.length; s++)
        a = i[s], !(n.indexOf(a) >= 0) && (o[a] = t[a]);
      return o;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(nt)), nt.exports;
}
const ml = /* @__PURE__ */ Ne(as), xl = /* @__PURE__ */ Ne(ss), $l = /* @__PURE__ */ Ne(bs), vl = /* @__PURE__ */ Ne(hc), Sl = /* @__PURE__ */ Ne(oc), wl = /* @__PURE__ */ Ne(cc);
var ar = io;
Object.defineProperty($r, "__esModule", {
  value: !0
});
var kl = $r.default = jl;
$r.shouldForwardProp = Pr;
$r.systemDefaultTheme = void 0;
var me = ar(yl()), pt = ar(hl()), mn = Rl(ml), Tl = xl, El = ar($l), _l = ar(vl), Cl = ar(Sl), Ol = ar(wl);
const Pl = ["ownerState"], Ml = ["variants"], Al = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function fo(e) {
  if (typeof WeakMap != "function") return null;
  var r = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (fo = function(n) {
    return n ? t : r;
  })(e);
}
function Rl(e, r) {
  if (!r && e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = fo(r);
  if (t && t.has(e)) return t.get(e);
  var n = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e) if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
    var a = o ? Object.getOwnPropertyDescriptor(e, i) : null;
    a && (a.get || a.set) ? Object.defineProperty(n, i, a) : n[i] = e[i];
  }
  return n.default = e, t && t.set(e, n), n;
}
function Il(e) {
  return Object.keys(e).length === 0;
}
function zl(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Pr(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Fl = $r.systemDefaultTheme = (0, Cl.default)(), xn = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function Tr({
  defaultTheme: e,
  theme: r,
  themeId: t
}) {
  return Il(r) ? e : r[t] || r;
}
function Dl(e) {
  return e ? (r, t) => t[e] : null;
}
function Mr(e, r) {
  let {
    ownerState: t
  } = r, n = (0, pt.default)(r, Pl);
  const o = typeof e == "function" ? e((0, me.default)({
    ownerState: t
  }, n)) : e;
  if (Array.isArray(o))
    return o.flatMap((i) => Mr(i, (0, me.default)({
      ownerState: t
    }, n)));
  if (o && typeof o == "object" && Array.isArray(o.variants)) {
    const {
      variants: i = []
    } = o;
    let s = (0, pt.default)(o, Ml);
    return i.forEach((c) => {
      let l = !0;
      typeof c.props == "function" ? l = c.props((0, me.default)({
        ownerState: t
      }, n, t)) : Object.keys(c.props).forEach((p) => {
        (t == null ? void 0 : t[p]) !== c.props[p] && n[p] !== c.props[p] && (l = !1);
      }), l && (Array.isArray(s) || (s = [s]), s.push(typeof c.style == "function" ? c.style((0, me.default)({
        ownerState: t
      }, n, t)) : c.style));
    }), s;
  }
  return o;
}
function jl(e = {}) {
  const {
    themeId: r,
    defaultTheme: t = Fl,
    rootShouldForwardProp: n = Pr,
    slotShouldForwardProp: o = Pr
  } = e, i = (a) => (0, Ol.default)((0, me.default)({}, a, {
    theme: Tr((0, me.default)({}, a, {
      defaultTheme: t,
      themeId: r
    }))
  }));
  return i.__mui_systemSx = !0, (a, s = {}) => {
    (0, mn.internal_processStyles)(a, (y) => y.filter((B) => !(B != null && B.__mui_systemSx)));
    const {
      name: c,
      slot: l,
      skipVariantsResolver: p,
      skipSx: h,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: b = Dl(xn(l))
    } = s, S = (0, pt.default)(s, Al), x = p !== void 0 ? p : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      l && l !== "Root" && l !== "root" || !1
    ), f = h || !1;
    let g;
    process.env.NODE_ENV !== "production" && c && (g = `${c}-${xn(l || "Root")}`);
    let k = Pr;
    l === "Root" || l === "root" ? k = n : l ? k = o : zl(a) && (k = void 0);
    const M = (0, mn.default)(a, (0, me.default)({
      shouldForwardProp: k,
      label: g
    }, S)), C = (y) => typeof y == "function" && y.__emotion_real !== y || (0, Tl.isPlainObject)(y) ? (B) => Mr(y, (0, me.default)({}, B, {
      theme: Tr({
        theme: B.theme,
        defaultTheme: t,
        themeId: r
      })
    })) : y, D = (y, ...B) => {
      let R = C(y);
      const we = B ? B.map(C) : [];
      c && b && we.push((J) => {
        const ne = Tr((0, me.default)({}, J, {
          defaultTheme: t,
          themeId: r
        }));
        if (!ne.components || !ne.components[c] || !ne.components[c].styleOverrides)
          return null;
        const ke = ne.components[c].styleOverrides, ue = {};
        return Object.entries(ke).forEach(([Be, se]) => {
          ue[Be] = Mr(se, (0, me.default)({}, J, {
            theme: ne
          }));
        }), b(J, ue);
      }), c && !x && we.push((J) => {
        var ne;
        const ke = Tr((0, me.default)({}, J, {
          defaultTheme: t,
          themeId: r
        })), ue = ke == null || (ne = ke.components) == null || (ne = ne[c]) == null ? void 0 : ne.variants;
        return Mr({
          variants: ue
        }, (0, me.default)({}, J, {
          theme: ke
        }));
      }), f || we.push(i);
      const Fe = we.length - B.length;
      if (Array.isArray(y) && Fe > 0) {
        const J = new Array(Fe).fill("");
        R = [...y, ...J], R.raw = [...y.raw, ...J];
      }
      const Oe = M(R, ...we);
      if (process.env.NODE_ENV !== "production") {
        let J;
        c && (J = `${c}${(0, El.default)(l || "")}`), J === void 0 && (J = `Styled(${(0, _l.default)(a)})`), Oe.displayName = J;
      }
      return a.muiName && (Oe.muiName = a.muiName), Oe;
    };
    return M.withConfig && (D.withConfig = M.withConfig), D;
  };
}
function Nl(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Ll = (e) => Nl(e) && e !== "classes", Bl = Ll, Wl = kl({
  themeId: pa,
  defaultTheme: bl,
  rootShouldForwardProp: Bl
}), ql = /* @__PURE__ */ Wl(re, {
  target: "e1dnh0e40"
})(() => Rn`
    display: grid;
    margin-bottom: 40px;
  `), Od = ({ title: e, component: r, rows: t = [], columns: n = [], width: o = "100%", height: i = "auto", gap: a = "8px", labelSize: s = "title-4-sb" }) => /* @__PURE__ */ Y(ge, {
  gap: 24,
  children: [
    e && /* @__PURE__ */ u(Ee, {
      variant: "title-1-md",
      children: e
    }),
    /* @__PURE__ */ Y(ql, {
      gap: a,
      width: o,
      height: i,
      gridTemplateColumns: `100px ${`repeat(${n.length}, 1fr)`}`,
      gridTemplateRows: `40px ${`repeat(${t.length}, 1fr)`}`,
      children: [
        /* @__PURE__ */ u("div", {}),
        n.map(({ name: c }) => /* @__PURE__ */ u(Ee, {
          variant: s,
          children: c
        }, c)),
        t.map(({ name: c, props: l }) => /* @__PURE__ */ Y(ni, {
          children: [
            /* @__PURE__ */ u(Ee, {
              variant: s,
              children: c
            }),
            n.map(({ name: p, props: h, width: b, height: S }) => /* @__PURE__ */ u(re, {
              height: S,
              width: b,
              children: /* @__PURE__ */ u(r, {
                ...l,
                ...h
              })
            }, `${p}_${c}`))
          ]
        }, c))
      ]
    })
  ]
}), Vl = /* @__PURE__ */ $(Po, ve, {
  target: "egbjv0t0"
})(({ theme: e, $borderRadius: r = 3 }) => d`
    border-radius: ${r}px;
    background-color: ${e.palette.grey[200]};
  `), tr = ({ animation: e = "wave", borderRadius: r = 3, ...t }) => /* @__PURE__ */ u(Vl, {
  animation: e,
  $borderRadius: r,
  ...t
}), Ul = (e) => d`
  padding: 16px 0;
  border-bottom: none;
  box-sizing: content-box;

  ${e.breakpoints.up("tablet")} {
    padding: 12px 0;
  }
`, Hl = (e) => d`
  position: relative;
  border-bottom: 1px solid ${e.palette.grey[200]};
  vertical-align: inherit;
  transition: background-color 0.3s;
  transform: translate(0);

  &:last-of-type {
    border-bottom: none;
  }

  &:hover {
    background: ${e.palette.grey[50]};
  }

  ${e.breakpoints.up("tablet")} {
    .${Mo.root} {
      &:first-of-type {
        padding-left: 12px;
      }

      &:last-of-type {
        padding-right: 12px;
      }
    }
  }
`, ft = /* @__PURE__ */ $(Ao, {
  target: "e1ptg9fu0"
})(({ theme: e }) => d`
    ${Ul(e)};
  `), go = /* @__PURE__ */ $(Ro, {
  target: "e1ptg9fu1"
})(({ theme: e }) => d`
    ${Hl(e)};
  `), Yl = (e, r) => {
  const t = e.render ? e.render(r) : r[e.key];
  return typeof t == "string" ? /* @__PURE__ */ u(Ie, {
    variant: "body-1",
    color: "grey.900",
    children: t
  }) : t;
}, Kl = ({ data: e, columns: r = [], ...t }) => {
  const { linkContainer: n } = e;
  return /* @__PURE__ */ Y(go, {
    ...t,
    children: [
      r.map((o) => {
        const { key: i, style: a } = o;
        return /* @__PURE__ */ u(ft, {
          style: a,
          children: Yl(o, e)
        }, i);
      }),
      /* @__PURE__ */ u(ft, {
        sx: {
          width: 0
        },
        children: n
      })
    ]
  });
}, Gl = ({ data: e, columns: r }) => {
  const t = e.length || 0;
  return /* @__PURE__ */ u(Tn, {
    sx: {
      verticalAlign: "inherit"
    },
    children: e.map((n, o) => /* @__PURE__ */ u(Kl, {
      data: n,
      columns: r,
      sx: {
        zIndex: t - o
      }
    }, n.id || o))
  });
}, Xl = ({ rowsCount: e = 5, columns: r = [] }) => {
  if (e <= 0)
    return null;
  const t = new Array(e).fill(0).map((n, o) => o);
  return /* @__PURE__ */ u(Tn, {
    sx: {
      verticalAlign: "inherit"
    },
    children: t.map((n) => /* @__PURE__ */ u(go, {
      children: r.map((o) => /* @__PURE__ */ u(ft, {
        style: o.style,
        children: o.render
      }, o.key))
    }, n))
  });
}, Pd = ({ columns: e = [], data: r = [], isLoading: t, skeleton: n, ...o }) => /* @__PURE__ */ u(Io, {
  ...o,
  children: t ? /* @__PURE__ */ u(Xl, {
    ...n
  }) : /* @__PURE__ */ u(Gl, {
    data: r,
    columns: e
  })
}), gt = {
  Light: "light",
  Dark: "dark"
}, bo = /* @__PURE__ */ $(({ className: e, textAlign: r, maxWidth: t, ...n }) => /* @__PURE__ */ u(zo, {
  classes: {
    popper: e
  },
  ...n
}), {
  target: "e1thekgj0"
})(({ theme: e, textAlign: r, maxWidth: t }) => d`
    & .${Me.tooltip} {
      text-align: ${r || "center"};
      max-width: ${t ? `${t}px` : "auto"};
      box-shadow: ${e.customShadows.lg};
      margin: 0;
    }
  `), Jl = /* @__PURE__ */ $(bo, {
  target: "e1thekgj1"
})(({ theme: e }) => d`
    & .${Me.tooltip} {
      ${Re("caption-1-md")}
      background-color: ${e.palette.common.white};
      color: ${e.palette.grey[700]};
      padding: 8px 12px;
      border-radius: 8px;

      & .${Me.arrow} {
        color: ${e.palette.common.white};
      }
    }
  `), Zl = /* @__PURE__ */ $(bo, {
  target: "e1thekgj2"
})(({ theme: e }) => d`
    .${Me.tooltip} {
      ${Re("body-2-md")}
      background-color: ${e.palette.grey[900]};
      color: ${e.palette.common.white};
      padding: 12px;
      border-radius: 12px;

      &.${Me.tooltipPlacementTop} .${Me.arrow} {
        bottom: 1px;
      }

      &.${Me.tooltipPlacementRight} .${Me.arrow} {
        left: 1px;
      }

      & .${Me.arrow} {
        color: ${e.palette.grey[900]};
      }
    }
  `), Ql = ({ mode: e = gt.Light, disableHoverListeners: r = !1, ...t }) => {
  const n = e === gt.Light ? Jl : Zl;
  return /* @__PURE__ */ u(n, {
    disableHoverListener: r,
    disableFocusListener: r,
    disableTouchListener: r,
    ...t
  });
}, eu = /* @__PURE__ */ $(Fo, {
  target: "efoyfqi0"
})(({ size: e, theme: r }) => d`
    flex-grow: 1;
    height: 8px;
    border-radius: 4px;
    background-color: ${r.palette.grey[200]};

    ${e === "xs" && d`
      height: 2px;
      border-radius: 0;
    `}

    ${e === "sm" && d`
      height: 4px;
      border-radius: 0;
    `}

  ${e === "md" && d`
      height: 12px;
      border-radius: 10px;
    `}

  .MuiLinearProgress-barColorPrimary {
      background-color: ${r.palette.primary[600]};
      border-radius: 6px;
    }
  `), ru = /* @__PURE__ */ $("div", {
  target: "efoyfqi1"
})(() => d`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
  `), tu = /* @__PURE__ */ $(Ee, {
  target: "efoyfqi2"
})(({ theme: e }) => d`
    color: ${e.palette.secondary.main};
    width: 37px;
  `), Md = ({ withLabel: e, ...r }) => /* @__PURE__ */ Y(ru, {
  children: [
    e ? /* @__PURE__ */ Y(tu, {
      variant: "body-2-md",
      children: [
        r.value,
        "%"
      ]
    }) : null,
    /* @__PURE__ */ u(eu, {
      variant: "determinate",
      ...r
    })
  ]
}), nu = /* @__PURE__ */ $(En, {
  target: "e1ejgpqx0"
})(({ theme: e, size: r }) => d`
    z-index: ${e.zIndex.dialog};

    .MuiDialog-container {
      align-items: flex-end;

      ${e.breakpoints.up("tablet")} {
        align-items: center;
      }
    }

    .MuiDialog-paper {
      position: relative;
      border-radius: 24px 24px 0 0;
      box-shadow: ${e.customShadows.xl};
      width: 100%;
      margin: 0;
      vertical-align: bottom;

      ${e.breakpoints.up("tablet")} {
        border-radius: 20px;
        vertical-align: middle;

        ${r === "sm" && d`
          max-width: 480px;
        `}

        ${r === "md" && d`
          max-width: 560px;
        `}

        ${r === "lg" && d`
          max-width: 800px;
        `}
      }

      ${e.breakpoints.up("laptop")} {
        margin: 32px;
      }
    }
  `), Ad = ({ children: e, ...r }) => /* @__PURE__ */ u(nu, {
  fullWidth: !0,
  ...r,
  children: e
}), ou = /* @__PURE__ */ $(ge, {
  target: "e12x1g6d0"
})(({ theme: e }) => d`
    padding: 15px 16px 24px;
    flex-direction: row;
    gap: 12px;

    ${e.breakpoints.up("mobileLarge")} {
      padding-right: 24px;
      padding-left: 24px;
    }
  `), Rd = ({ children: e, ...r }) => /* @__PURE__ */ u(ou, {
  ...r,
  children: e
}), iu = /* @__PURE__ */ $(_n, {
  target: "e1rlnpyl0"
})(({ theme: e }) => d`
    display: flex;
    flex-direction: column;
    padding: 24px 16px 20px;
    width: 100%;

    ${e.breakpoints.up("mobileLarge")} {
      padding: 24px 24px 20px;
    }
  `), au = /* @__PURE__ */ $(re, {
  target: "e1rlnpyl1"
})(() => d`
    display: flex;
    gap: 8px;
  `), su = /* @__PURE__ */ $(re, ve, {
  target: "e1rlnpyl2"
})(({ $maxLines: e, theme: r }) => d`
    margin-right: 24px;
    color: ${r.palette.grey[900]};

    ${e === 1 && In}

    ${e && e > 1 && zn(e)}
  `), cu = /* @__PURE__ */ $($t, {
  target: "e1rlnpyl3"
})(({ theme: e }) => d`
    display: none;

    svg {
      ${be(24)};
      fill: none;
      stroke: ${e.palette.grey[500]};
    }

    ${e.breakpoints.up("mobileLarge")} {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `), lu = /* @__PURE__ */ $($t, {
  target: "e1rlnpyl4"
})(({ theme: e }) => d`
    position: absolute;
    top: 18px;
    right: 18px;

    svg {
      ${be(24)};
      stroke: ${e.palette.grey[500]};
    }

    ${e.breakpoints.up("mobileLarge")} {
      top: 26px;
      right: 24px;
    }
  `), uu = /* @__PURE__ */ $(Ee, {
  target: "e1rlnpyl5"
})(() => d`
    margin-top: 8px;
  `), Id = ({ onClose: e, onBack: r, buttonsDisabled: t, renderTitle: n, renderSubtitle: o, maxLines: i, ...a }) => /* @__PURE__ */ Y(iu, {
  variant: "title-4-md",
  ...a,
  children: [
    /* @__PURE__ */ Y(au, {
      children: [
        r && /* @__PURE__ */ u(cu, {
          onClick: r,
          disabled: t,
          disableBackground: !0,
          children: /* @__PURE__ */ u(pi, {})
        }),
        /* @__PURE__ */ u(su, {
          $maxLines: i,
          children: n
        }),
        /* @__PURE__ */ u(lu, {
          onClick: e,
          disabled: t,
          disableBackground: !0,
          children: /* @__PURE__ */ u(mt, {
            width: 24,
            height: 24
          })
        })
      ]
    }),
    o && /* @__PURE__ */ u(uu, {
      color: "grey.500",
      variant: "body-2",
      children: o
    })
  ]
}), du = /* @__PURE__ */ $(ge, {
  target: "eov09se0"
})(({ theme: e }) => d`
    padding-right: 16px;
    padding-left: 16px;

    ${e.breakpoints.up("mobileLarge")} {
      padding-right: 24px;
      padding-left: 24px;
    }
  `), zd = ({ children: e, ...r }) => /* @__PURE__ */ u(du, {
  ...r,
  children: e
}), pu = {
  xs: 480,
  sm: 560,
  md: 720,
  lg: 800
}, fu = /* @__PURE__ */ $(En, {
  target: "eedudie0"
})(({ theme: e, size: r = "xs" }) => d`
    z-index: ${e.zIndex.dialog};

    .${Do.backdrop} {
      background: rgba(0, 0, 0, 0.5);
    }

    .${zt.container} {
      align-items: flex-end;

      ${e.breakpoints.up("tablet")} {
        align-items: center;
      }
    }

    .${zt.paper} {
      position: relative;
      border-radius: 20px 20px 0 0;
      box-shadow: ${e.customShadows.xl};
      width: 100%;
      margin: 0;
      vertical-align: bottom;

      ${e.breakpoints.up("tablet")} {
        border-radius: 20px;
        max-width: ${pu[r]}px;
        vertical-align: middle;
      }
    }
  `), Fd = /* @__PURE__ */ $(re, {
  target: "eedudie1"
})(() => d`
    display: flex;
  `), Dd = /* @__PURE__ */ $(ge, {
  target: "eedudie2"
})(() => d`
    width: 100%;
  `), jd = ({ children: e, fullWidth: r = !0, size: t = "xs", ...n }) => /* @__PURE__ */ u(fu, {
  fullWidth: r,
  size: t,
  ...n,
  children: e
}), gu = /* @__PURE__ */ $(re, ve, {
  target: "e18uj5hd0"
})(({ theme: e, $noPadding: r = !1, $noActions: t = !1 }) => d`
    padding: ${r ? 0 : "24px"} 16px ${t ? "16px" : 0};
    background-color: ${e.palette.common.white};

    ${e.breakpoints.up("tablet")} {
      padding: ${r ? 0 : "24px"} 24px ${t ? "24px" : 0};
    }
  `), Nd = ({ children: e, noPadding: r = !1, noActions: t = !1, ...n }) => /* @__PURE__ */ u(gu, {
  $noPadding: r,
  $noActions: t,
  ...n,
  children: e
}), bu = /* @__PURE__ */ $(ge, ve, {
  target: "e1lbir5z0"
})(({ theme: e, $noTopPadding: r }) => d`
    padding: 16px;
    flex-direction: row;
    gap: 12px;
    background-color: ${e.palette.common.white};

    ${e.breakpoints.up("tablet")} {
      padding: 24px;
    }

    ${r && d`
      padding-top: 0;

      ${e.breakpoints.up("tablet")} {
        padding-top: 0;
      }
    `}
  `), Ld = ({ children: e, noTopPadding: r, ...t }) => /* @__PURE__ */ u(bu, {
  $noTopPadding: r,
  ...t,
  children: e
}), yu = /* @__PURE__ */ $(re, {
  target: "e10bxpzx0"
})(({ theme: e }) => d`
    display: none;
    min-width: 180px;
    max-width: 180px;
    box-sizing: border-box;
    padding: 12px 10px 0;
    border-right: 1px solid ${e.palette.grey[200]};
    background-color: ${e.palette.common.white};

    ${e.breakpoints.up("tablet")} {
      display: block;
    }
  `), Bd = ({ children: e, ...r }) => /* @__PURE__ */ u(yu, {
  ...r,
  children: e
}), Wd = ({ hook: e, children: r }) => {
  const { isOpen: t } = e();
  return t ? r : null;
}, hu = /* @__PURE__ */ $(_n, ve, {
  target: "e11cqsv00"
})(({ theme: e, $underline: r }) => d`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    padding: 24px 16px 16px;
    background-color: ${e.palette.common.white};
    min-height: 24px;

    ${e.breakpoints.up("tablet")} {
      padding: 24px 24px 16px;
    }

    ${r && d`
      border-bottom: 1px solid ${e.palette.grey[200]};
    `}
  `), mu = /* @__PURE__ */ $($t, {
  target: "e11cqsv01"
})(({ theme: e }) => d`
    position: absolute;
    right: 16px;
    top: 24px;
    padding: 10px;
    margin-right: -10px;
    margin-top: -10px;

    ${e.breakpoints.up("tablet")} {
      right: 24px;
    }
  `), xu = ({ isCloseButtonDisabled: e, children: r, onClose: t, underline: n, customCloseIcon: o = /* @__PURE__ */ u(mt, {
  width: 24,
  height: 24
}), ...i }) => /* @__PURE__ */ Y(hu, {
  $underline: n,
  ...i,
  children: [
    r,
    t ? /* @__PURE__ */ u(mu, {
      disabled: e,
      disableBackground: !0,
      disableRipple: !0,
      onClick: t,
      children: o
    }) : null
  ]
}), $u = ({ children: e, ...r }) => /* @__PURE__ */ u(Ie, {
  variant: "body-2",
  color: "grey.500",
  ...r,
  children: e
}), vu = ({ children: e, ...r }) => /* @__PURE__ */ u(Ie, {
  variant: "title-4-md",
  color: "grey.900",
  ...r,
  children: e
}), qd = {
  Container: xu,
  Title: vu,
  Subtitle: $u
}, Su = /* @__PURE__ */ $("header", {
  target: "e1lzxklm0"
})(({ theme: e }) => d`
    display: flex;
    border-bottom: 1px solid ${e.palette.grey[200]};
    background-color: ${e.palette.common.white};
    min-height: 54px;
    max-height: 54px;

    ${e.breakpoints.up("tablet")} {
      min-height: 72px;
      max-height: 72px;
    }
  `), wu = /* @__PURE__ */ $(re, {
  target: "e1lzxklm1"
})(({ theme: e }) => d`
    ${be(54)};
    border-right: 1px solid ${e.palette.grey[200]};

    ${e.breakpoints.up("tablet")} {
      ${be(72)};
    }
  `), ku = /* @__PURE__ */ $(re, {
  target: "e1lzxklm2"
})(() => d`
    padding: 0;
    display: grid;
    flex: 1;
    align-content: center;
    align-items: center;
  `), Tu = /* @__PURE__ */ $(re, {
  target: "e1lzxklm3"
})(({ theme: e }) => d`
    margin-left: auto;
    padding-right: 16px;
    display: flex;
    align-items: center;

    ${e.breakpoints.up("tablet")} {
      padding-right: 20px;
    }
  `), Vd = ({ leftBlock: e, rightBlock: r, children: t, className: n, style: o }) => /* @__PURE__ */ Y(Su, {
  className: n,
  style: o,
  children: [
    /* @__PURE__ */ u(wu, {
      children: e
    }),
    t && /* @__PURE__ */ u(ku, {
      children: t
    }),
    r && /* @__PURE__ */ u(Tu, {
      children: r
    })
  ]
}), Ud = /* @__PURE__ */ ye(({ color: e = "grey.200", ...r }, t) => /* @__PURE__ */ u(jo, {
  sx: {
    borderColor: e
  },
  ref: t,
  ...r
})), bt = {
  color: "primary",
  size: "xs"
}, yo = (e, r = bt.size) => {
  const t = {
    xs: {
      font: e.typography["caption-2-md"],
      iconSize: 12
    },
    sm: {
      font: e.typography["caption-1-md"],
      iconSize: 16
    },
    md: {
      font: e.typography["body-2-md"],
      iconSize: 20
    },
    lg: {
      font: e.typography["body-1-md"],
      iconSize: 20
    }
  };
  return t[r] || t[bt.size];
}, Eu = (e, r = bt.color) => ({
  common: e.palette[r][700],
  hover: e.palette[r][900],
  focus: e.palette[r][900],
  disabled: e.palette.grey[300]
}), At = {
  color: "primary",
  size: "sm"
}, _u = (e = !1) => d`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: 0.2s color;

    ${e && d`
      pointer-events: none;
    `}
  `, Cu = (e, r = At.size) => {
  const { font: t } = yo(e, r);
  return d`
    font-size: ${t == null ? void 0 : t.fontSize}px;
    line-height: ${t == null ? void 0 : t.lineHeight};
    font-weight: ${t == null ? void 0 : t.fontWeight};
  `;
}, Ou = (e, r = At.size) => {
  const { iconSize: t } = yo(e, r);
  return d`
    ${be(t)};
  `;
}, Pu = (e, r = At.color, t = !1) => {
  const { common: n, hover: o, focus: i, disabled: a } = Eu(e, r);
  return d`
    color: ${n};

    &:hover {
      color: ${o};
    }
    &:focus {
      color: ${i};
    }

    ${t && d`
      color: ${a};
    `}
  `;
}, Mu = /* @__PURE__ */ $(No, ve, {
  target: "eu80kiw0"
})(({ theme: e, $size: r, $disabled: t, $color: n }) => d`
    ${Cu(e, r)};
    ${_u(t)};
    ${Pu(e, n, t)}
  `), $n = /* @__PURE__ */ $(re, {
  target: "eu80kiw1"
})(({ theme: e, $size: r }) => d`
    ${Ou(e, r)}
  `), Hd = ({ size: e = "sm", underline: r = "none", disabled: t = !1, color: n = "primary", startIcon: o, children: i, endIcon: a, component: s, ...c }) => /* @__PURE__ */ Y(Mu, {
  component: s,
  underline: r,
  $disabled: t,
  $size: e,
  $color: n,
  ...c,
  children: [
    o && /* @__PURE__ */ u($n, {
      children: o
    }),
    /* @__PURE__ */ u("span", {
      children: i
    }),
    a && /* @__PURE__ */ u($n, {
      children: a
    })
  ]
}), Au = /* @__PURE__ */ $(Lo, {
  target: "ebehqr00"
})(({ theme: e }) => d`
    border: 1px solid ${e.palette.grey[100]};
    border-radius: 12px;
    padding: 4px;
    box-shadow: ${e.customShadows.xl};

    .MuiList-root {
      padding: 0;
    }
  `), Ru = /* @__PURE__ */ $(yt, {
  target: "ebehqr01"
})(({ theme: e }) => d`
    padding: 10px 8px;
    min-height: 48px;

    &:hover {
      background-color: ${e.palette.grey[100]};
      border-radius: 8px;
    }
  `), Iu = /* @__PURE__ */ $(dr, {
  target: "ebehqr02"
})(({ theme: e }) => d`
    color: ${e.palette.common.black};
  `), zu = /* @__PURE__ */ $(re, {
  target: "ebehqr03"
})(() => d`
    ${be(24)};
  `), Fu = /* @__PURE__ */ $(re, {
  target: "ebehqr04"
})(({ theme: e }) => d`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 24px;
    color: ${e.palette.common.black};
  `), Du = /* @__PURE__ */ $(Ee, {
  target: "ebehqr05"
})(({ theme: e }) => d`
    color: ${e.palette.common.black};
  `), ju = /* @__PURE__ */ $(re, {
  target: "ebehqr06"
})(() => d`
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
  `), Nu = ({ onClose: e, options: r, anchorRef: t, open: n, width: o = 200, placement: i = "bottom-end", offset: a, disablePortal: s = !0, zIndex: c, ...l }) => /* @__PURE__ */ u(Bo, {
  open: n,
  anchorEl: t == null ? void 0 : t.current,
  role: void 0,
  transition: !0,
  disablePortal: s,
  placement: i,
  sx: (p) => ({
    zIndex: c || p.zIndex.popover,
    width: o
  }),
  ...l,
  children: ({ TransitionProps: p }) => /* @__PURE__ */ u(Wo, {
    in: !0,
    timeout: 100,
    ...p,
    children: /* @__PURE__ */ u(Au, {
      style: {
        marginTop: i === "top" ? 0 : a,
        marginBottom: i === "top" ? a : 0
      },
      children: /* @__PURE__ */ u(qo, {
        onClickAway: e,
        children: /* @__PURE__ */ u(Vo, {
          children: r.map(({ id: h, label: b, icon: S, action: x, isLoading: f, disabled: g, htmlId: k }) => /* @__PURE__ */ u(Ru, {
            onClick: async (M) => {
              await (x == null ? void 0 : x(M)), e == null || e(M);
            },
            disabled: g,
            id: k,
            children: /* @__PURE__ */ Y(ju, {
              children: [
                f ? /* @__PURE__ */ u(zu, {
                  children: /* @__PURE__ */ u(Iu, {
                    size: 20
                  })
                }) : /* @__PURE__ */ u(Fu, {
                  children: S
                }),
                /* @__PURE__ */ u(Du, {
                  variant: "body-2-md",
                  children: b
                })
              ]
            })
          }, h))
        })
      })
    })
  })
}), Lu = /* @__PURE__ */ $(re, {
  target: "e86q0t30"
})(() => d`
    display: flex;
  `), Bu = /* @__PURE__ */ $(re, {
  target: "e86q0t31"
})(() => d`
    display: inline-flex;
  `), Wu = ({ isMenuStopPropagation: e, open: r, handleOpen: t }) => {
  const n = r !== void 0 && t, [o, i] = ht(n ? r : !1), a = oi(null), { isMobile: s } = Fn();
  return {
    openMenu: n ? r : o,
    ref: a,
    isMobile: s,
    toggleMenu: (p) => {
      e && p.stopPropagation(), i((h) => !h), t == null || t(!r);
    },
    closeMenu: (p) => {
      e && p.stopPropagation(), i(!1), t == null || t(!1);
    }
  };
}, qu = /* @__PURE__ */ $(re, {
  target: "e1uzdmg20"
})(({ theme: e }) => d`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: ${e.zIndex.popover};
  `), Vu = /* @__PURE__ */ $(ge, {
  target: "e1uzdmg21"
})(({ theme: e }) => d`
    background: ${e.palette.common.white};
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${e.zIndex.dialog};
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 24px 20px;
    gap: 8px;
  `), Uu = /* @__PURE__ */ $(dr, {
  target: "e1uzdmg22"
})(({ theme: e }) => d`
    color: ${e.palette.common.black};
  `), Hu = /* @__PURE__ */ $(re, {
  target: "e1uzdmg23"
})(() => d`
    ${be(24)};
  `), Yu = /* @__PURE__ */ $(yt, {
  target: "e1uzdmg24"
})(({ theme: e, disabled: r }) => d`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    position: relative;
    border: 1px solid ${e.palette.grey[200]};
    padding: 16px;
    border-radius: 10px;

    svg {
      ${be(20)};
      fill: none;
    }

    ${r && d`
      &.${Er.disabled} {
        color: ${e.palette.grey[300]};
        opacity: 1;
      }
    `}
  `), Ku = ({ onClose: e, options: r, isMenuStopPropagation: t }) => /* @__PURE__ */ Y(ii, {
  children: [
    /* @__PURE__ */ u(qu, {
      onClick: e
    }),
    /* @__PURE__ */ u(Vu, {
      children: r.map(({ id: n, label: o, rightLabel: i, icon: a, action: s, isLoading: c, disabled: l, htmlId: p }) => /* @__PURE__ */ Y(Yu, {
        onClick: (b) => {
          t && b.stopPropagation(), s == null || s(b), p ? setTimeout(() => {
            e == null || e(b);
          }, 0) : e == null || e(b);
        },
        disabled: l,
        id: p,
        children: [
          /* @__PURE__ */ Y(ge, {
            flexDirection: "row",
            alignItems: "center",
            gap: 8,
            children: [
              c ? /* @__PURE__ */ u(Hu, {
                children: /* @__PURE__ */ u(Uu, {
                  size: 20
                })
              }) : a,
              /* @__PURE__ */ u(Ee, {
                variant: "body-2-md",
                color: l ? "grey.300" : "common.black",
                children: o
              })
            ]
          }),
          i && /* @__PURE__ */ u(Ee, {
            variant: "body-2-md",
            color: l ? "grey.300" : "common.black",
            alignSelf: "flex-end",
            children: i
          })
        ]
      }, n))
    })
  ]
}), Yd = ({ width: e = 200, offset: r = 4, children: t, options: n, placement: o, isMenuStopPropagation: i = !1, disableMobileView: a = !1, handleOpen: s, open: c, disablePortal: l, zIndexPopover: p, ...h }) => {
  const { openMenu: b, ref: S, toggleMenu: x, closeMenu: f, isMobile: g } = Wu({
    open: c,
    handleOpen: s,
    isMenuStopPropagation: i
  });
  return /* @__PURE__ */ Y(Lu, {
    ...h,
    children: [
      /* @__PURE__ */ u(Bu, {
        ref: S,
        onClick: x,
        children: t
      }),
      !a && b && g && /* @__PURE__ */ u(Ku, {
        options: n,
        onClose: f,
        isMenuStopPropagation: i
      }),
      /* @__PURE__ */ u(Nu, {
        anchorRef: S,
        options: n,
        open: !a && g ? !1 : b,
        onClose: f,
        width: e,
        offset: r,
        placement: o,
        disablePortal: l,
        zIndex: p
      })
    ]
  });
}, Gu = /* @__PURE__ */ $(Uo, {
  target: "e3zywpq0"
})(({ theme: e }) => d`
    padding-right: 0;

    .MuiMobileStepper-dots {
      gap: 12px;
    }

    .MuiMobileStepper-dot {
      background: ${e.palette.grey[100]};
    }

    .MuiMobileStepper-dotActive {
      background: ${e.palette.primary[700]};
    }

    &.MuiPaper-root {
      padding: 0;
    }
  `), Kd = ({ steps: e = 1, backButton: r = /* @__PURE__ */ u("span", {}), nextButton: t = /* @__PURE__ */ u("span", {}), position: n = "static", ...o }) => /* @__PURE__ */ u(Gu, {
  steps: e,
  position: n,
  backButton: r,
  nextButton: t,
  ...o
}), Xu = /* @__PURE__ */ $(re, {
  target: "e131ktxf0"
})(() => d`
    display: inline-flex;
    flex: 1;
  `), Ju = /* @__PURE__ */ $(Ho, {
  target: "e131ktxf1"
})(({ theme: e }) => d`
    ${Re("body-2-md")};
    font-family: inherit;
    min-width: auto;
    padding: 0;
    color: ${e.palette.grey[500]};

    ${e.breakpoints.between("tablet", "laptop")} {
      ${Re("caption-1-md")}
    }

    ${e.breakpoints.up("laptop")} {
      ${Re("body-2-md")};
    }

    &.Mui-selected {
      color: ${e.palette.grey[700]};
      cursor: default;
    }
  `), Gd = ({ disabled: e, tooltipMessage: r, isRightOffset: t = !1, ...n }) => /* @__PURE__ */ u(Ql, {
  maxWidth: 200,
  placement: "bottom",
  disableHoverListeners: !r || !e,
  title: r,
  arrow: !0,
  mode: gt.Dark,
  PopperProps: {
    // modifiers to add right offset to last tab tooltip if there are three tabs
    modifiers: t ? [
      {
        name: "offset",
        options: {
          offset: [
            -60
          ]
        }
      }
    ] : []
  },
  children: /* @__PURE__ */ u(Xu, {
    children: /* @__PURE__ */ u(Ju, {
      disabled: e,
      ...n
    })
  })
}), Zu = /* @__PURE__ */ $(Yo, {
  target: "engfsa30"
})(({ theme: e }) => d`
    margin-bottom: 12px;
    border-bottom: 1px solid ${e.palette.grey[200]};
    min-height: 52px;

    & .${Ko.indicator} {
      background-color: ${e.palette.grey[700]};
    },
  `), Xd = (e) => /* @__PURE__ */ u(Zu, {
  variant: "fullWidth",
  indicatorColor: "secondary",
  ...e
}), Qu = (e) => d`
  .${Go.ul} {
    gap: 2px;

    li {
      &:first-of-type {
        margin-right: auto;

        ${e.breakpoints.up("laptop")} {
          margin-right: 18px;
        }
      }

      &:last-of-type {
        margin-left: auto;

        ${e.breakpoints.up("laptop")} {
          margin-left: 18px;
        }
      }
    }
  }

  .${Sr.page}, .${Sr.ellipsis} {
    ${Re("body-2-md")};
    ${be(40)};
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${e.palette.grey[500]};
    border-radius: 8px;
  }

  .${Sr.page} {
    &:hover,
    &.Mui-selected {
      background-color: ${e.palette.grey[50]};

      &:hover {
        background-color: ${e.palette.grey[50]};
      }
    }

    &:hover {
      color: ${e.palette.grey[700]};
    }

    &.Mui-selected {
      color: ${e.palette.grey[900]};
    }
  }

  .${Sr.previousNext} {
    ${be(20)};
    padding: 0;
    margin: 0;
    color: ${e.palette.grey[500]};

    svg {
      width: 100%;
      height: 100%;
    }

    &:hover {
      background-color: transparent;
      color: ${e.palette.grey[600]};
    }

    &.Mui-disabled {
      opacity: 1;
      color: ${e.palette.grey[300]};
    }
  }
`, ed = /* @__PURE__ */ $(Xo, {
  target: "e1s77hha0"
})(({ theme: e }) => d`
    ${Qu(e)}
  `), Jd = ({ isLoading: e, ...r }) => {
  const { isMobile: t, isTablet: n } = Fn(), o = t || n;
  return e ? /* @__PURE__ */ Y(ge, {
    direction: "row",
    gap: o ? 12 : 20,
    alignItems: "center",
    justifyContent: o ? "space-between" : void 0,
    children: [
      /* @__PURE__ */ u(tr, {
        width: 20,
        height: 20,
        borderRadius: 4,
        variant: "rectangular"
      }),
      /* @__PURE__ */ u(tr, {
        width: o ? 220 : 292,
        height: 40,
        borderRadius: 4,
        variant: "rectangular"
      }),
      /* @__PURE__ */ u(tr, {
        width: 20,
        height: 20,
        borderRadius: 4,
        variant: "rectangular"
      })
    ]
  }) : /* @__PURE__ */ u(ed, {
    shape: "rounded",
    variant: "text",
    siblingCount: o ? 0 : void 0,
    renderItem: (i) => /* @__PURE__ */ u(Jo, {
      slots: {
        previous: Mn,
        next: An
      },
      ...i
    }),
    ...r
  });
}, rd = (e) => {
  if (e <= 9)
    return 10;
  if (e >= 10 && e <= 99)
    return 20;
  if (e >= 100 && e <= 999)
    return 28;
  if (e >= 1e3 && e <= 9999)
    return 36;
}, Zd = ({ isLoading: e, page: r = 1, count: t = 1, handleNextPage: n, handlePrevPage: o, ...i }) => {
  const a = r === 1, s = r === t;
  return e ? /* @__PURE__ */ Y(ge, {
    direction: "row",
    gap: 4,
    ...i,
    children: [
      /* @__PURE__ */ u(tr, {
        width: 20,
        height: 20,
        borderRadius: 4,
        variant: "rectangular"
      }),
      /* @__PURE__ */ u(tr, {
        width: 48,
        height: 20,
        borderRadius: 4,
        variant: "rectangular"
      }),
      /* @__PURE__ */ u(tr, {
        width: 20,
        height: 20,
        borderRadius: 4,
        variant: "rectangular"
      })
    ]
  }) : /* @__PURE__ */ Y(ge, {
    direction: "row",
    gap: 4,
    alignItems: "center",
    ...i,
    children: [
      /* @__PURE__ */ u(it, {
        startIcon: /* @__PURE__ */ u(Mn, {}),
        type: "button",
        variant: "text",
        size: "sm",
        title: "Previous Page",
        disabled: a,
        onClick: o,
        noPadding: !0
      }),
      /* @__PURE__ */ Y(Ie, {
        variant: "body-2-md",
        color: "grey.500",
        children: [
          /* @__PURE__ */ u(Ie, {
            component: "span",
            variant: "inherit",
            color: "inherit",
            sx: {
              display: "inline-flex"
            },
            minWidth: rd(r),
            children: r
          }),
          " ",
          "of ",
          t
        ]
      }),
      /* @__PURE__ */ u(it, {
        startIcon: /* @__PURE__ */ u(An, {}),
        type: "button",
        variant: "text",
        size: "sm",
        title: "Next Page",
        disabled: s,
        onClick: n,
        noPadding: !0
      })
    ]
  });
}, td = /* @__PURE__ */ $(Zo, {
  target: "e1asnm5v0"
})(({ theme: e }) => d`
    z-index: ${e.zIndex.popup};
    pointer-events: none;
  `), nd = /* @__PURE__ */ $(ge, {
  target: "e4up5tt0"
})(({ theme: e }) => d`
    border-radius: 8px;
    min-width: 200px;
    max-width: 313px;
    padding: 12px;
    gap: 4px;
    background-color: ${e.palette.common.white};
    box-shadow: ${e.customShadows["2xl"]};
  `), od = /* @__PURE__ */ $(ge, ve, {
  target: "e4up5tt1"
})(({ theme: e, $severity: r }) => d`
    flex-direction: row;
    justify-content: space-between;
    color: ${e.palette[r][700]};
    margin-bottom: 10px;
  `), id = /* @__PURE__ */ $(mt, ve, {
  target: "e4up5tt2"
})(({ theme: e, $severity: r }) => d`
    cursor: pointer;
    pointer-events: auto;
    color: ${e.palette[r][500]};
  `), vn = /* @__PURE__ */ $(Ee, {
  target: "e4up5tt3"
})(() => d`
    padding-right: 20px;
  `), ad = ({ isOpen: e, title: r, subtitle: t, severity: n = "error", onCloseIconClick: o, onUnmount: i }) => (On(() => () => {
  e || i();
}, [
  i,
  e
]), /* @__PURE__ */ Y(nd, {
  children: [
    /* @__PURE__ */ Y(od, {
      $severity: n,
      children: [
        /* @__PURE__ */ u(fi, {
          width: 20,
          height: 20
        }),
        /* @__PURE__ */ u(id, {
          width: 20,
          height: 20,
          onClick: o,
          $severity: n
        })
      ]
    }),
    r ? /* @__PURE__ */ u(vn, {
      variant: "caption-1-md",
      color: `${n}.700`,
      children: r
    }) : null,
    t ? /* @__PURE__ */ u(vn, {
      variant: "caption-1",
      color: `${n}.500`,
      children: t
    }) : null
  ]
})), Qd = ({ title: e, subtitle: r, severity: t = "error", onClose: n }) => {
  const [o, i] = ht(!1), a = () => {
    i(!1);
  };
  return On(() => {
    e && i(!0);
  }, [
    e
  ]), /* @__PURE__ */ u(td, {
    open: o,
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    children: /* @__PURE__ */ u("div", {
      children: /* @__PURE__ */ u(ad, {
        isOpen: o,
        title: e,
        subtitle: r,
        severity: t,
        onCloseIconClick: a,
        // we call onClose only on unmount because of an animation delay
        onUnmount: n
      })
    })
  });
};
export {
  it as Button,
  wd as ButtonGroup,
  vd as Checkbox,
  Cd as Chip,
  Ad as Dialog,
  Rd as DialogActions,
  zd as DialogContent,
  Id as DialogTitle,
  Ud as Divider,
  xt as FONT_FAMILY,
  Vd as Header,
  at as Icon,
  $t as IconButton,
  ea as Input,
  Hd as Link,
  Od as MatrixState,
  Yd as Menu,
  jd as Modal,
  Ld as ModalActions,
  Nd as ModalContent,
  qd as ModalHeader,
  Bd as ModalSidebar,
  Wd as ModalWrapper,
  Jd as Pagination,
  Nu as Popover,
  Md as Progressbar,
  Sd as Radio,
  kd as Rating,
  Qd as RightTopToast,
  Fd as SModalWithSidebar,
  Dd as SModalWithSidebarContent,
  Ed as Select,
  _d as SelectItem,
  ia as SelectLabel,
  tr as Skeleton,
  Td as Slider,
  Zd as SmallPagination,
  Kd as Stepper,
  Gd as Tab,
  Pd as Table,
  Xd as Tabs,
  $d as TextField,
  Ql as Tooltip,
  gt as TooltipMode,
  Ie as Typography,
  xi as breakpoints,
  oa as createSelectRenderValue,
  hd as getAllPaletteColorOptions,
  Dt as getPaletteColor,
  Re as getTextStyles,
  zn as lineClampCSS,
  In as lineEllipsisCSS,
  md as noop,
  bd as px,
  $i as shadows,
  Ti as speakersPalette,
  gd as speakersPaletteTokensList,
  be as squareBlockCSS,
  ve as styledOmitCustomProps,
  ae as theme,
  xd as useCopy,
  Fn as useDeviceType,
  _i as wait,
  yd as waveKeyframe,
  wi as zIndex
};
